export const de = {
    "login": "Anmeldung",
    "register": "Registrierung",
    "username": "Benutzername",
    "password": "Passwort",
    "email": "E-Mail",
    "go-back": "Zurück",
    "EmailConfirmed_PleaseWait": "E-Mail wurde bestätigt. Bitte warten...",
    "EmailConfirmationErrorPage_Title": "Fehler bei der E-Mail-Bestätigung",
    "EmailConfirmationErrorPage_Text": "Es gab einen Fehler bei der E-Mail-Bestätigung. Bitte versuchen Sie es erneut.",
    "EmailConfirmed_Success": "E-Mail erfolgreich bestätigt.",
    "The Username field is required.": "Das Feld Benutzername ist erforderlich.",
    "The Email field is required.": "Das Feld E-Mail ist erforderlich.",
    "The Password field is required.": "Das Feld Passwort ist erforderlich.",
    "EmailConfirmationErrorPage_BackButton": "Zurück",
    "redirector.unknownRoleForUsingApp": "Sie haben noch keinen Zugriff auf die Anwendung zugewiesen bekommen.",
    "NotFoundPage_Title": "Seite nicht gefunden",
    "NotFoundPage_BackButton": "Zurück",
    "NotFoundPage_Text": "Die gesuchte Seite wurde nicht gefunden.",
    "ConfirmYourEmail": "Ein Bestätigungslink wurde an Ihre E-Mail gesendet. Bitte bestätigen Sie Ihre E-Mail.",
    "User email not confirmed": "E-Mail nicht bestätigt",
    "EmailNotConfirmed": "E-Mail nicht bestätigt",
    "ResendConfirmationEmail": "Bestätigungslink erneut senden",
    "ResendConfirmationEmail_Success": "Bestätigungslink erfolgreich gesendet.",
    "PasswordTooShort": "Passwort ist zu kurz.",
    "User not found": "Benutzer nicht gefunden.",
    "back": "Zurück",
    "home": "Startseite",
    "logout": "Abmelden",
    "users": "Benutzer",
    "users-description": "Übersicht der Benutzer",
    "organization-members": "Organisationsmitglieder",
    "organization-members-description": "Organisator-Konten verwalten",
    "organization-member": "Organisationsmitglied",
    "add-organization-member": "Mitglied hinzufügen",
    "resend-onboarding": "Onboarding erneut senden",
    "pending-onboarding": "Onboarding ausstehend",
    "organization-member-created": "Organisationsmitglied erstellt",
    "organization-member-onboarding-sent": "Onboarding-E-Mail gesendet",
    "administrator-only-page": "Diese Seite ist nur für Administratoren verfügbar.",
    "administration": "Verwaltung",
    "error-loading-items": "Fehler beim Laden der Artikel",
    "search": "Suche",
    "clear-filter": "Filter löschen",
    "change-type": "Änderungstyp",
    "created-by": "Erstellt von",
    "created-between": "Erstellt zwischen",
    "state": "Status",
    "created": "Erstellt",
    "changes": "Änderungen",
    "Previous": "Vorherige",
    "Next": "Nächste",
    "create": "Hinzufügen",
    "code": "Code",
    "cancel": "Abbrechen",
    "save": "Speichern",
    "id": "Schlüssel",
    "emailConfirmed": "E-Mail bestätigt",
    "are-you-sure-you-want-to-delete-this-item": "Sind Sie sicher, dass Sie diesen Artikel löschen möchten?",
    "delete": "Löschen",
    "page": "Seite",
    "InvalidEmail": "Geben Sie eine gültige E-Mail ein",
    "additional": "Zusätzlich",
    "resendConfirmationEmail": "Bestätigungslink erneut senden",
    "no-items": "Keine Artikel",
    "status": "Status",
    "date": "Datum",
    "roles": "Rollen",
    "Admin": "Administrator",
    "Customer": "Kunde",
    "taxId": "Steuernummer",
    "actions": "Aktionen",
    "locations": "Standorte",
    "address": "Adresse",
    "location-name": "Standortname",
    "geodecode-address": "Adresse auf Karte suchen",
    "import-locations": "Standorte importieren",
    "adding-users": "Benutzer hinzufügen",
    "notification": "Benachrichtigung",
    "successfully-deleted-item": "Artikel erfolgreich gelöscht",
    "successfully-deleted-item-with-id": "Artikel mit ID erfolgreich gelöscht",
    "error-deleting-item-with-id": "Fehler beim Löschen des Elements mit ID",
    "successfully-duplicated-item-with-id": "Element mit ID erfolgreich dupliziert",
    "error-duplicating-item-with-id": "Fehler beim Duplizieren des Elements mit ID",
    "company": "Firma",
    "linkedin-url": "LinkedIn-URL",
    "InvalidUserName": "Geben Sie einen gültigen Benutzernamen ein",
    "editing-users": "Benutzer bearbeiten",
    "edit": "Bearbeiten",
    "show-only-unassigned": "Nur nicht zugewiesene anzeigen",
    "settings": "Einstellungen",
    "start-search": "Suche starten",
    "isMainLocation": "Hauptstandort",
    "assign": "Zuweisen",
    "assigned-user": "Dem Benutzer zugewiesen",
    "details": "Details",
    "user": "Benutzer",
    "user-overview": "Benutzerübersicht",
    "MANAGER": "Manager",
    "user-details": "Benutzerdetails",
    "confirmationEmailSent": "Bestätigungs-E-Mail gesendet",
    "userName": "Benutzername",
    "firstName": "Vorname",
    "lastName": "Nachname",
    "system": "System",
    "basic-data": "Grunddaten",
    "role": "Rolle",
    "languages-full:hr": "Kroatisch",
    "languages-full:en": "Englisch",
    "languages-full:de": "Deutsch",
    "languages-full:it": "Italienisch",
    "duplicate": "Duplizieren",
    "name": "Name",
    "name-hr": "Name (Kroatisch)",
    "name-en": "Name (Englisch)",
    "place": "Ort",
    "description": "Beschreibung",
    "event-information": "Eventinformationen",
    "event-information-hr": "Eventinformationen (Kroatisch)",
    "event-information-en": "Eventinformationen (Englisch)",
    "on-site-registration-instructions": "Anweisungen zur Registrierung vor Ort",
    "on-site-registration-instructions-hr": "Anweisungen zur Registrierung vor Ort (Kroatisch)",
    "on-site-registration-instructions-en": "Anweisungen zur Registrierung vor Ort (Englisch)",
    "nameAndDescription": "Name und Beschreibung",
    "NoResults": "Keine Ergebnisse",
    "dateTime": "Datum und Uhrzeit",
    "initiatingUser": "Initiator",
    "deactivated": "Deaktiviert",
    "parent": "Übergeordnet",
    "parentId": "Übergeordnete ID",
    "Email already exists": "E-Mail existiert bereits",
    "unassigned": "Nicht zugewiesen",
    "note": "Notiz",
    "first-page": "Erste Seite",
    "next-page": "Nächste Seite",
    "previous-page": "Vorherige Seite",
    "last-page": "Letzte Seite",
    "yes": "Ja",
    "no": "Nein",
    "warning": "Warnung",
    "phoneNumber": "Telefonnummer",
    "preferredLanguage": "Bevorzugte Sprache",
    "enums:COMPLETED": "Erledigt",
    "enums:CANCELLED": "Abgesagt",
    "quantity": "Menge",
    "add-row": "Zeile hinzufügen",
    "header": "Überschrift",
    "basics": "Grundlagen",
    "priority": "Priorität",
    "BackGoToLogin": "Zurück zum Login",
    "close": "Schließen",
    "notes": "Notizen",
    "createdAt": "Erstellungsdatum und -zeit",
    "error-occurred": "Es ist ein Fehler aufgetreten",
    "reload": "Neu laden",
    "user-updated-successfully": "Benutzer erfolgreich aktualisiert",
    "profile-updated": "Profil aktualisiert",
    "location": "Standort",
    "requested-by": "Angefordert von",
    "startDate": "Startdatum",
    "endDate": "Enddatum",
    "count": "Anzahl",
    "xlsx_export": "Export in Excel",
    "csv_export": "Export in CSV",
    "current-page": "Seite",
    "page-of": "von",
    "value": "Wert",
    "Login": "Anmeldung",
    "change-password": "Passwort ändern",
    "oldPassword": "Altes Passwort",
    "newPassword": "Neues Passwort",
    "password-changed": "Passwort geändert",
    "password-reset": "Passwort zurücksetzen",
    "password-reset-successful": "Passwort erfolgreich zurückgesetzt",
    "no-data": "Keine Daten",
    "events-and-forms": "Events & Registrierungs-Setup",
    "attendees-and-registrations": "Teilnehmer und Anmeldungen",
    "finance": "Finanzen",
    "resources": "Ressourcen",
    "events": "Events",
    "events-description": "Erstellen und verwalten Sie Events, Zeitpläne und veröffentlichte Zugangscodes.",
    "registration-forms": "Öffentliche Registrierung",
    "registration-forms-description": "Teilen Sie die Live-URL der öffentlichen Registrierung pro Event.",
    "accommodations": "Unterkünfte",
    "accommodations-description": "Verwalten Sie Unterkunftsoptionen, die an Events gekoppelt sind.",
    "room-allotments": "Zimmerkontingente",
    "room-allotments-description": "Planen Sie Zimmerblöcke und verfolgen Sie die Verfügbarkeit pro Nacht.",
    "participants": "Teilnehmer",
    "participants-description": "Verwalten Sie die Personen, die an Ihren Events teilnehmen.",
    "registrations": "Anmeldungen",
    "registrations-description": "Prüfen Sie Anmeldungen, Status und zugewiesene Unterkünfte.",
    "notifications": "Benachrichtigungen",
    "notifications-description": "Prüfen Sie den E-Mail-Zustellverlauf des Veranstalters.",
    "general-settings": "Allgemeine Einstellungen",
    "general-settings-description": "Verwalten Sie Zahlungsempfaenger und Standardsteuerwerte.",
    "public-event-forms": "Live-Registrierung teilen",
    "public-event-forms-description": "Teilen Sie die gehostete öffentliche Registrierungs-URL und das iFrame. Setup-Änderungen erscheinen dort sofort.",
    "public-registration-share": "Öffentliche Registrierung teilen",
    "public-registration-share-description": "Verwenden Sie die gehostete URL für einen normalen WordPress-Link oder kopieren Sie das iFrame-Snippet für eine freigegebene Einbettung.",
    "recipient-email": "Empfänger-E-Mail",
    "sent-by": "Gesendet von",
    "sent-at": "Gesendet um",
    "failed-at": "Fehlgeschlagen um",
    "failure-message": "Fehlermeldung",
    "notification-history-count": "{{count}} Zustellprotokolle",
    "select-event-to-view-notifications": "Wählen Sie ein Event aus, um den Benachrichtigungsverlauf anzuzeigen.",
    "notification-status:SENT": "Gesendet",
    "notification-status:FAILED": "Fehlgeschlagen",
    "notification-status:DRAFT": "Entwurf",
    "cta.new-event": "Neues Event",
    "cta.view-schedule": "Zeitplan anzeigen",
    "cta.preview-form": "Formularvorschau",
    "cta.new-accommodation": "Neue Unterkunft",
    "cta.manage-room-types": "Zimmertypen verwalten",
    "cta.new-room-allotment": "Neues Zimmerkontingent",
    "cta.adjust-allotment": "Kontingent anpassen",
    "cta.new-participant": "Teilnehmer hinzufügen",
    "cta.import-participants": "Teilnehmer importieren",
    "cta.new-registration": "Anmeldung hinzufügen",
    "cta.assign-accommodation": "Unterkunft zuweisen",
    "cta.view-public-form": "Öffentliches Formular öffnen",
    "cta.copy-public-link": "Öffentlichen Link kopieren",
    "cta.save": "Speichern",
    "cta.edit-definition": "Definition bearbeiten",
    "start-date": "Startdatum",
    "end-date": "Enddatum",
    "capacity": "Kapazität",
    "beds": "Betten",
    "rooms": "Zimmer",
    "assigned": "Zugewiesen",
    "remaining": "Verfügbar",
    "total-rooms": "Gesamtzahl Zimmer",
    "version": "Version",
    "fields": "Felder",
    "event": "Event",
    "participant": "Teilnehmer",
    "group": "Gruppe",
    "members": "Mitglieder",
    "balance": "Saldo",
    "payer": "Zahler",
    "reference": "Referenz",
    "payment": "Zahlung",
    "target": "Ziel",
    "amount": "Betrag",
    "linked-to": "Verknüpft mit",
    "filters": "Filter",
    "filter.event": "Event",
    "event-drilldown": "Von einem Event aus starten",
    "cta.view-registrations": "Anmeldungen",
    "cta.view-rooming": "Unterkünfte",
    "cta.view-forms": "Formulare",
    "method": "Methode",
    "paid-at": "Bezahlt am",
    "packageCode": "Paketcode",
    "logo-url": "Eventlogo-Datei",
    "program-pdf-url": "Programm-PDF-Datei",
    "venue-layout-image-url": "Lageplan-Bilddatei",
    "sponsors-image-url": "Sponsorbild-Datei",
    "primary-color": "Primärfarbe",
    "secondary-color": "Sekundärfarbe",
    "badge-template-url": "Badge-Grafikdatei",
    "certificate-template-url": "Zertifikatsvorlage-Datei",
    "certificate-name-x": "Namensplatzierung - horizontaler Abstand",
    "certificate-name-y": "Namensplatzierung - vertikaler Abstand",
    "validation.color-required": "{{field}} ist erforderlich.",
    "validation.hex-color": "{{field}} muss eine HEX-Farbe wie #223F6B sein.",
    "validation.field-required": "{{field}} ist erforderlich.",
    "validation.required-field": "Pflichtfeld",
    "validation.number": "{{field}} muss eine Zahl sein.",
    "price-period-start-date-required": "Startdatum ist erforderlich.",
    "price-period-end-date-required": "Enddatum ist erforderlich.",
    "price-period-end-before-start": "Enddatum muss am oder nach dem Startdatum liegen.",
    "price-period-overlap": "Preiszeiträume dürfen sich nicht überschneiden. Dieser Zeitraum überschneidet sich mit {{period}} ({{startDate}} - {{endDate}}).",
    "organizerName": "Organisator",
    "sponsorName": "Sponsor",
    "about-app-changelog": "Neuigkeiten",
    "about-app-description": "EventFlow unterstützt Veranstalter bei der Vorbereitung von Veranstaltungen, der Verwaltung von Teilnehmeranmeldungen und der Arbeit vor Ort.",
    "about-app-error": "Versionsinformationen sind derzeit nicht verfügbar.",
    "about-app-title": "Über die App",
    "about-app-version": "Version",
    "accommodation": "Unterkunft",
    "accommodation-choice": "Gewählte Unterkunft",
    "accommodation-offer": "Unterkunftsangebot",
    "accommodation-offer-total": "Unterkunft gesamt: {{amount}}",
    "accommodation-payment": "Zahlung der Unterkunft",
    "accommodation-payment-not-issued": "Nicht ausgestellt",
    "accommodation-payment-status": "Zahlungsstatus der Unterkunft",
    "accommodation-ppo": "Unterkunfts-PPO",
    "accommodation-ppo-default": "Standard-PPO für Unterkunft",
    "accommodation-ppo-required": "Unterkunfts-PPO ist erforderlich.",
    "accommodation-reservations": "Unterkunftsreservierungen",
    "accommodation-reserved": "Reserviert",
    "accommodation-tax-scheme": "Steuermodell der Unterkunft",
    "accommodation-vat": "Unterkunfts-PPO",
    "accommodation-vat-default": "Standard-PPO für Unterkunft",
    "accommodation-vat-required": "Unterkunfts-PPO ist erforderlich.",
    "action": "Aktion",
    "active": "Aktiv",
    "active-codes": "Aktive Codes",
    "active-codes-count": "{{count}} aktive Codes",
    "active-events": "Aktive Veranstaltungen",
    "activities": "Aktivitäten",
    "activity-allowed-fee-types": "Zulässige Teilnehmergebührenarten",
    "activity-public-registration-end-date": "Anmeldeschluss für die Aktivität",
    "activity-tracks-usage-or-attendance": "Nutzung/Anwesenheit erfassen?",
    "activity-visibility-rule": "Sichtbarkeitsregel",
    "activity-visible-after-activity": "Sichtbar nach Aktivität",
    "activity-visible-after-answer": "Erwartete Antwort",
    "additional-info": "Zusätzlich",
    "address-required": "Adresse ist erforderlich.",
    "all": "Alle",
    "all-payers": "Alle Zahler",
    "allocated-amount": "Zugeordnet",
    "amount-gross": "Bruttobetrag",
    "amount-net": "Nettobetrag",
    "app-channel-not-active": "App nicht aktiv",
    "apply-filters": "Filter anwenden",
    "archive": "Archiv",
    "archive-description": "Archivierte Veranstaltungen und Betriebshistorie ansehen.",
    "archive-state": "Archivstatus",
    "archived": "Archiviert",
    "archived-at": "Archiviert am",
    "archived-event": "Archivierte Veranstaltung",
    "archived-events": "Archivierte Veranstaltungen",
    "archived-events-count": "{{count}} archivierte Veranstaltungen",
    "are-you-sure-you-want-to-delete-selected-items": "Möchten Sie die ausgewählten Einträge wirklich löschen?",
    "arrival": "Anreise",
    "asset-mode-combined-pdf": "Ein PDF",
    "asset-mode-separate-program-layout": "Programm + Lageplan",
    "ati-logo-alt": "ATI-Logo",
    "back-to-participants": "Zurück zu den Teilnehmenden",
    "badge-template-back-file": "Datei für die Rückseite der Akkreditierung",
    "badge-template-front-file": "Datei für die Vorderseite der Akkreditierung",
    "badge-template.back": "Rückseite",
    "badge-template.back-empty": "Laden Sie die Rückseite hoch, um die Position des QR-Codes zu prüfen.",
    "badge-template.back-preview-alt": "Vorschau der Akkreditierungsrückseite",
    "badge-template.editor": "Visueller Editor für Akkreditierungen",
    "badge-template.first-name": "Vorname",
    "badge-template.front": "Vorderseite",
    "badge-template.front-empty": "Laden Sie die Vorderseite hoch, um die Platzierung zu prüfen.",
    "badge-template.front-preview-alt": "Vorschau der Akkreditierungsvorderseite",
    "badge-template.incomplete": "Unvollständig",
    "badge-template.institution": "Institution",
    "badge-template.last-name": "Nachname",
    "badge-template.load-error": "Akkreditierungsvorlage nicht verfügbar",
    "badge-template.qr-code": "QR-Code",
    "badge-template.ready": "Bereit",
    "badge-template.saved": "Akkreditierungsvorlage gespeichert",
    "badge-template.title": "Akkreditierungsvorlage",
    "body": "Inhalt",
    "branding-and-assets": "Branding und Grafiken",
    "branding-assets-certificate": "Branding, Dokumente und Bescheinigung",
    "category": "Kategorie",
    "category-codes": "Kategoriecodes",
    "certificate": "Bescheinigung",
    "certificate-count": "{{count}} Bescheinigungen",
    "certificate-document": "Bescheinigungsdokument",
    "certificate-eligibility": "Bereitschaft der Bescheinigung",
    "certificate-email-queue-failed": "Die E-Mail mit der Bescheinigung konnte nicht in die Warteschlange gestellt werden.",
    "certificate-email-queued": "E-Mail mit der Bescheinigung in die Warteschlange gestellt.",
    "certificate-event-completion-required": "Nach Abschluss der Veranstaltung verfügbar",
    "certificate-generated": "Bescheinigung bereit",
    "certificate-generation-failed": "Bescheinigung konnte nicht erstellt werden",
    "certificate-history": "Verlauf der Bescheinigungen",
    "certificate-issued": "Ausgestellt",
    "certificate-issued-filter": "Ausgestellt",
    "certificate-not-eligible": "Nicht bereit",
    "certificate-not-ready": "Nicht bereit",
    "certificate-pdf": "Bescheinigung als PDF",
    "certificate-ready": "Bereit",
    "certificate-registered-status": "Bereit",
    "certificate-request-description": "Verwenden Sie nach Abschluss der Veranstaltung den Link aus Ihrer QR-Einladung, um eine Bescheinigung anzufordern.",
    "certificate-request-load-failed": "Anmeldedaten konnten nicht geladen werden.",
    "certificate-request-missing-token": "Im Link zur Bescheinigungsanforderung fehlt ein Anmeldetoken.",
    "certificate-request-submit-failed": "Die Anforderung der Bescheinigung konnte nicht gesendet werden.",
    "certificate-request-success": "Anforderung der Bescheinigung erhalten.",
    "certificate-request-title": "Bescheinigung anfordern",
    "certificate-state": "Status der Bescheinigung",
    "certificate-template-file": "Datei der Bescheinigungsvorlage",
    "certificate-template.editor": "Visueller Editor für Bescheinigungen",
    "certificate-template.empty": "Laden Sie eine Bescheinigungsvorlage hoch, um die Platzierung zu prüfen.",
    "certificate-template.incomplete": "Unvollständig",
    "certificate-template.load-error": "Bescheinigungsvorlage nicht verfügbar",
    "certificate-template.participant-name": "Name der teilnehmenden Person",
    "certificate-template.preview-alt": "Vorschau der Bescheinigungsvorlage",
    "certificate-template.ready": "Bereit",
    "certificate-template.saved": "Bescheinigungsvorlage gespeichert",
    "certificate-template.title": "Bescheinigungsvorlage",
    "certificates": "Bescheinigungen",
    "check-in.badge-download-failed": "Die Akkreditierung konnte nicht erstellt werden.",
    "check-in.badge-download-missing": "Scannen Sie zuerst einen gültigen Code.",
    "check-in.badge-downloaded": "Druckfertige Akkreditierung heruntergeladen.",
    "check-in.badge-missing": "Fehlt",
    "check-in.badge-ready": "Bereit",
    "check-in.download-badge": "Akkreditierung herunterladen",
    "check-in.failure-message": "Hinweis zum Druckproblem",
    "check-in.failure-message-required": "Ein Hinweis zum Druckproblem ist erforderlich.",
    "check-in.outcome.blocked": "Nicht berechtigt",
    "check-in.outcome.eligible": "Druckbereit",
    "check-in.outcome.invalid": "Ungültiger Code",
    "check-in.outcome.revoked": "Code widerrufen",
    "check-in.outcome.unknown": "Unbekannter Status",
    "check-in.outcome.wrong-event": "Falsche Veranstaltung",
    "check-in.print-failed": "Druck fehlgeschlagen",
    "check-in.print-failure-failed": "Das Druckproblem konnte nicht erfasst werden.",
    "check-in.print-failure-recorded": "Druckproblem erfasst.",
    "check-in.print-recorded": "Druckergebnis erfasst.",
    "check-in.print-result-missing": "Scannen Sie zuerst einen gültigen Code und geben Sie einen Stationsnamen ein.",
    "check-in.print-status": "Druckstatus",
    "check-in.print-succeeded": "Druck erfolgreich",
    "check-in.print-success-failed": "Der erfolgreiche Druck konnte nicht erfasst werden.",
    "check-in.print-success-recorded": "Erfolgreicher Druck erfasst.",
    "check-in.registration-code-token": "Token des Anmeldecodes",
    "check-in.registration-updated": "Anmeldung in den Status Registriert verschoben.",
    "check-in.report-print-failed": "Druckproblem erfassen",
    "check-in.report-print-success": "Druck erfolgreich",
    "check-in.scan": "Code scannen",
    "check-in.scan-failed": "Der Anmeldecode konnte nicht gescannt werden.",
    "check-in.station-error": "Fehler der Check-in-Station",
    "check-in.station-identifier": "Stationsname",
    "check-in.station-title": "Check-in-Station",
    "check-in.token-required": "Das Token des Anmeldecodes ist erforderlich.",
    "check-in.token-url-invalid": "Die gescannte URL enthält kein Token eines Anmeldecodes.",
    "checked-in": "Eingecheckt",
    "city": "Stadt",
    "clear": "Leeren",
    "clear-filters": "Filter zurücksetzen",
    "clear-search": "Suche leeren",
    "clipboard-unavailable": "Zwischenablage ist nicht verfügbar",
    "code-required": "Code ist erforderlich.",
    "combined-program-layout-pdf-url": "PDF-Datei mit Programm und Lageplan",
    "company-payee-name": "Name des Unternehmens/Zahlungsempfängers",
    "condition": "Bedingung",
    "condition-type": "Bedingungstyp",
    "config.accommodation": "Unterkunftseinstellungen",
    "config.email-templates": "E-Mail-Vorlagen",
    "config.languages": "Sprachen",
    "config.options": "Anmeldeoptionen",
    "config.pricing": "Preise",
    "config.tax": "Steuereinstellungen",
    "config.tax-description": "Diese Steuerwerte fließen in Gebühren- und Unterkunftsangebote ein. Halten Sie sie mit den tatsächlichen Abrechnungsregeln der Veranstaltung abgestimmt.",
    "configuration-fallback": "Standard",
    "confirm": "Bestätigen",
    "confirm-new-password": "Neues Passwort bestätigen",
    "confirm-new-password-required": "Bestätigen Sie das neue Passwort.",
    "country": "Land",
    "created-timeline": "Erstellt: {{value}}",
    "cta.clone": "Klonen",
    "cta.copied": "Kopiert",
    "cta.copy": "Kopieren",
    "cta.create-event": "Veranstaltung erstellen",
    "cta.manage-hotels-and-room-types": "Hotels und Zimmertypen verwalten",
    "currency": "Währung",
    "customer-purchase-order": "Bestellung des Kunden",
    "customer-purchase-order-download-failed": "Die Bestellung des Kunden konnte nicht heruntergeladen werden.",
    "customer-purchase-order-missing": "Fehlt",
    "customer-purchase-order-upload-failed": "Die Bestellung des Kunden konnte nicht gespeichert werden.",
    "customer-purchase-order-upload-success": "Bestellung des Kunden gespeichert.",
    "date-range": "Zeitraum",
    "dates": "Termine",
    "deactivate": "Deaktivieren",
    "delete-confirmation-count-target": "Zum Löschen ausgewählte Einträge ({{itemType}}): {{count}}.",
    "delete-confirmation-named-target": "{{itemType}} „{{itemName}}“ wird gelöscht.",
    "delete-confirmation-question": "Möchten Sie den Eintrag wirklich löschen?",
    "delete-confirmation-target": "{{itemType}} wird gelöscht.",
    "delete-confirmation-title": "Löschen bestätigen",
    "delete-target-accommodation-option": "Unterkunftsoption",
    "delete-target-event-access": "Veranstaltungszugriff",
    "delete-target-file": "Datei",
    "delete-target-hotel": "Hotel",
    "delete-target-invitation": "Ausstehende Einladung",
    "delete-target-participant": "Teilnehmende Person",
    "delete-target-payer": "Zahler",
    "delete-target-record": "Eintrag",
    "delete-target-template-field": "Vorlagenfeld",
    "delivery-note": "Zustellhinweis",
    "delivery-timeline": "Zustellverlauf",
    "departure": "Abreise",
    "depends-on-code": "Abhängig vom Code",
    "depends-on-value": "Abhängig vom Wert",
    "description-en": "Beschreibung (Englisch)",
    "description-hr": "Beschreibung (Kroatisch)",
    "description-required": "Beschreibung ist erforderlich.",
    "developer-feedback-description": "Problembeschreibung",
    "developer-feedback-error": "Ihre Meldung konnte gerade nicht gesendet werden. Bitte versuchen Sie es erneut.",
    "developer-feedback-help": "Beschreiben Sie, was passiert ist. Ihr Name und Ihre E-Mail-Adresse werden an das Entwicklungsteam übermittelt.",
    "developer-feedback-placeholder": "Was wollten Sie tun und was ist passiert?",
    "developer-feedback-queued": "Ihre Meldung ist eingegangen und wartet auf den Versand.",
    "developer-feedback-send": "Meldung senden",
    "developer-feedback-title": "Problem melden",
    "document-ready": "Verfügbar",
    "document-unavailable": "Nicht verfügbar",
    "download": "Herunterladen",
    "download-certificate": "Bescheinigung herunterladen",
    "download-customer-purchase-order": "Bestellung herunterladen",
    "download-offer": "Angebot herunterladen",
    "download-rooming-csv": "Rooming-CSV herunterladen",
    "due-date": "Fälligkeitsdatum",
    "edit-organization-member": "Mitglied bearbeiten",
    "eligibility-actions": "Aktionen zur Berechtigung",
    "email-channel-active": "E-Mail aktiv",
    "email-delivery": "E-Mail-Zustellung",
    "email-delivery-history": "Verlauf der E-Mail-Zustellung",
    "email-delivery-history-error-title": "Zustellverlauf ist nicht verfügbar",
    "email-delivery-history-helper": "Verwenden Sie E-Mail für Veranstaltungsbenachrichtigungen. App- und Push-Zustellung sind in dieser Web-App nicht aktiv.",
    "email-delivery-ok": "Kein Zustellfehler erfasst.",
    "email-delivery-queued": "In Warteschlange",
    "email-notifications": "E-Mail-Benachrichtigungen",
    "email-recipient": "E-Mail-Empfänger",
    "email-signature": "E-Mail-Signatur",
    "email-template-footer": "Fußzeile",
    "email-template-header": "Kopfzeile",
    "email-unverified": "Unbestätigt",
    "email-verification": "E-Mail-Bestätigung",
    "email-verified": "Bestätigt",
    "emailed": "Per E-Mail gesendet",
    "end-date-required": "Enddatum ist erforderlich.",
    "entity": "Entität",
    "enums:ACCOMMODATION": "Unterkunft",
    "enums:ACTIVE": "Aktiv",
    "enums:ADD_LINE_ITEM": "Position hinzufügen",
    "enums:ADMINISTRATOR": "Administrator",
    "enums:ALWAYS": "Immer",
    "enums:ARCHIVED": "Archiviert",
    "enums:BANK_TRANSFER": "Banküberweisung",
    "enums:CARD": "Karte",
    "enums:CASH": "Bargeld",
    "enums:CATEGORY_ONLY": "Nur Kategorie",
    "enums:NO_CHARGE": "Kostenlos",
    "enums:CHECKBOX": "Kontrollkästchen",
    "enums:COMPANY": "Unternehmen",
    "enums:DATE": "Datum",
    "enums:DEPENDS_ON_ANSWER": "Abhängig von der Antwort",
    "enums:DRAFT": "Entwurf",
    "enums:EMAIL": "E-Mail",
    "enums:EMAILED": "Per E-Mail gesendet",
    "enums:EN": "Englisch",
    "enums:EXPIRED": "Abgelaufen",
    "enums:FAILED": "Fehlgeschlagen",
    "enums:GENERATED": "Erstellt",
    "enums:HR": "Kroatisch",
    "enums:INDIVIDUAL": "Privatperson",
    "enums:MANUALLY_RECONCILED": "Manuell abgeglichen",
    "enums:MULTI_CHOICE": "Mehrfachauswahl",
    "enums:MULTI_SELECT": "Mehrfachauswahl",
    "enums:NUMBER": "Zahl",
    "enums:PAID": "Bezahlt",
    "enums:PARTICIPATION": "Teilnahmegebühr",
    "enums:PENDING": "Ausstehend",
    "enums:PHONE": "Telefon",
    "enums:POS": "POS",
    "enums:PPO": "PPO",
    "enums:REFUNDED": "Erstattet",
    "enums:RELEASED": "Freigegeben",
    "enums:REPLACED": "Ersetzt",
    "enums:RESERVED": "Reserviert",
    "enums:SELECT": "Auswahl",
    "enums:SINGLE_CHOICE": "Einfachauswahl",
    "enums:SPONSOR": "Sponsor",
    "enums:STANDARD_VAT": "Standard-MwSt.",
    "enums:TEXT": "Text",
    "enums:TEXT_AREA": "Mehrzeiliger Text",
    "enums:UNPAID": "Unbezahlt",
    "enums:USER": "Benutzer",
    "enums:YES_NO": "Ja / Nein",
    "error": "Fehler",
    "error-deleting-item": "Eintrag konnte nicht gelöscht werden",
    "error.download-failed": "Download fehlgeschlagen",
    "error.upload-failed": "Upload fehlgeschlagen",
    "errors.unknown": "Unbekannter Fehler",
    "event-access-card-title": "Veranstaltungszugriff",
    "event-access-empty": "Keine Mitwirkenden",
    "event-access-grant": "Zugriff gewähren",
    "event-access-granted": "Veranstaltungszugriff gewährt",
    "event-access-revoke": "Entziehen",
    "event-access-revoked": "Veranstaltungszugriff entzogen",
    "event-access-user-placeholder": "Veranstalter",
    "event-audit.action": "Aktion",
    "event-audit.action.archived": "Archiviert",
    "event-audit.action.created": "Erstellt",
    "event-audit.action.deleted": "Gelöscht",
    "event-audit.action.restored": "Wiederhergestellt",
    "event-audit.action.updated": "Bearbeitet",
    "event-audit.details": "Details",
    "event-audit.empty": "Für diese Veranstaltung wurden keine Änderungen erfasst.",
    "event-audit.entity": "Entität / ID",
    "event-audit.event-archived-details-prefix": "Veranstaltung archiviert",
    "event-audit.load-error": "Audit konnte nicht geladen werden",
    "event-audit.load-error-description": "Aktualisieren Sie die Seite oder versuchen Sie es später erneut.",
    "event-audit.time": "Zeit",
    "event-audit.user": "Benutzer",
    "event-basic-setup": "Grundeinstellungen der Veranstaltung",
    "event-basic-setup-guided": "Grunddaten und öffentlicher Text",
    "event-basic-setup-saved": "Veranstaltungseinstellungen gespeichert",
    "event-config-accommodation-hotel-required": "Wählen Sie ein Hotel aus dem Katalog oder fügen Sie zuerst ein neues Hotel hinzu.",
    "event-config-accommodation-hotel-select": "Hotel aus dem globalen Katalog",
    "event-config-accommodation-hotel-select-placeholder": "Hotel aus dem Katalog wählen",
    "event-config-accommodation-new-hotel": "Neues Hotel im Katalog",
    "event-config-accommodation-new-hotel-placeholder": "Hotelnamen eingeben, falls er fehlt",
    "event-config-accommodation-option-saved": "Unterkunftsoption gespeichert",
    "event-config-accommodation-options": "Unterkunftsoptionen",
    "event-config-accommodation-options-deleted": "Unterkunftsoptionen gelöscht",
    "event-config-accommodation-options-description": "Legen Sie Hotel, Zimmertyp, Preis, buchbares Kontingent, Aufenthaltszeitraum und Zahlungsfrist in einer Zeile fest. Hotels stammen aus dem globalen Hotelkatalog; fehlt ein Hotel, fügen Sie es hier hinzu – es bleibt für künftige Veranstaltungen gespeichert.",
    "event-config-accommodation-options-empty": "Noch keine Unterkunftsoptionen.",
    "event-config-accommodation-period-missing": "Zeitraum fehlt",
    "event-config-accommodation-price-invalid": "Der Preis muss null oder größer sein.",
    "event-config-add-accommodation-option": "Unterkunftsoption hinzufügen",
    "event-config-add-fee-row": "Preiszeile hinzufügen",
    "event-config-add-hotel-to-catalog": "Hotel zum Katalog hinzufügen",
    "event-config-add-room-inventory": "Zimmerkontingent hinzufügen",
    "event-config-add-room-type": "Zimmertyp hinzufügen",
    "event-config-delete-accommodation-option-title": "Unterkunftsoption löschen?",
    "event-config-delete-accommodation-options-confirm": "Möchten Sie die ausgewählten Unterkunftsoptionen wirklich löschen?",
    "event-config-delete-accommodation-options-reservations-confirm": "Mit den folgenden Unterkunftsoptionen sind Reservierungen verknüpft: {{options}}. Beim Löschen der Optionen werden auch diese Reservierungen entfernt. Möchten Sie sie wirklich löschen?",
    "event-config-delete-accommodation-options-reservations-warning": "Mit den folgenden Unterkunftsoptionen sind Reservierungen verknüpft: {{options}}. Beim Löschen der Optionen werden auch diese Reservierungen entfernt.",
    "event-config-delete-accommodation-options-title": "Unterkunftsoptionen löschen?",
    "event-config-edit-accommodation-option": "Unterkunftsoption bearbeiten",
    "event-config-event-hotels": "Hotels dieser Veranstaltung",
    "event-config-fee-price-prerequisite-description": "Fügen Sie {{items}} hinzu, bevor Sie Preiszeilen anlegen.",
    "event-config-fee-price-requires-period": "mindestens einen Preiszeitraum",
    "event-config-fee-price-requires-type": "mindestens eine Teilnehmergebührenart",
    "event-config-fee-prices-guided": "Preiszeilen",
    "event-config-fee-prices-prerequisite-title": "Schließen Sie die Gebühreneinrichtung ab, bevor Sie Preiszeilen anlegen.",
    "event-config-fee-types-guided": "Teilnehmergebührenarten",
    "event-config-guided-accommodation": "Unterkunftseinstellungen",
    "event-config-hotel-catalog-choice": "Katalog",
    "event-config-hotel-create-empty-response": "Das Hotel wurde nach dem Speichern nicht zurückgegeben.",
    "event-config-hotel-link-empty-response": "Das Hotel wurde nach dem Verknüpfen nicht zurückgegeben.",
    "event-config-hotel-name-required": "Hotelname ist erforderlich.",
    "event-config-hotel-saved": "Hotel gespeichert",
    "event-config-hotel-unavailable": "Hotel nicht verfügbar",
    "event-config-hotels-empty-description": "Verknüpfen Sie ein vorhandenes Hotel oder fügen Sie einen neuen Hotelnamen hinzu, bevor Sie Zimmertypen festlegen.",
    "event-config-hotels-empty-title": "Noch keine Hotels verknüpft",
    "event-config-link-hotel-action": "Hotel verknüpfen",
    "event-config-link-hotel-empty": "Noch keine wiederverwendbaren Hotels verfügbar.",
    "event-config-link-hotel-help": "Wählen Sie ein wiederverwendbares Hotel aus dem gemeinsamen Katalog, um es mit dieser Veranstaltung zu verknüpfen.",
    "event-config-link-hotel-label": "Hotel verknüpfen, das bereits bei einer anderen Veranstaltung verwendet wird",
    "event-config-new-accommodation-option": "Neue Unterkunftsoption",
    "event-config-new-hotel-action": "Hotel hinzufügen",
    "event-config-new-hotel-label": "Neuen Hotelnamen zu dieser Veranstaltung hinzufügen",
    "event-config-new-hotel-placeholder": "Name des Hotels oder Veranstaltungsorts",
    "event-config-operator-tax": "Steuer für Gebühren und Unterkunft",
    "event-config-participant-emails": "E-Mails an Teilnehmende",
    "event-config-room-allotment-prerequisite-description": "Verknüpfen oder ergänzen Sie {{items}}, bevor Sie ein Zimmerkontingent hinzufügen.",
    "event-config-room-allotment-requires-hotel": "ein Hotel",
    "event-config-room-allotment-requires-room-type": "einen Zimmertyp",
    "event-config-room-allotments-prerequisite-title": "Schließen Sie Hotels und Zimmertypen ab, bevor Sie ein Zimmerkontingent hinzufügen.",
    "event-config-room-capacity-invalid": "Die Zimmerkapazität muss eine ganze Zahl größer als null sein.",
    "event-config-room-inventory": "Zimmerkontingent und Zahlungsfristen",
    "event-config-room-type-empty-response": "Der Zimmertyp wurde nach dem Speichern nicht zurückgegeben.",
    "event-config-room-type-name-placeholder": "Name des Zimmertyps",
    "event-config-room-type-name-required": "Name des Zimmertyps ist erforderlich.",
    "event-config-room-type-prerequisite-description": "Verknüpfen oder ergänzen Sie {{items}}, bevor Sie Zimmertypen hinzufügen.",
    "event-config-room-type-requires-hotel": "ein Hotel",
    "event-config-room-type-unavailable": "Zimmertyp nicht verfügbar",
    "event-config-room-types-prerequisite-title": "Verknüpfen Sie ein Hotel, bevor Sie Zimmertypen hinzufügen.",
    "event-config-room-types-setup": "Buchbare Zimmertypen",
    "event-config-save-accommodation-option": "Unterkunftsoption speichern",
    "event-config-save-hotel": "Hotel speichern",
    "event-config-total-rooms-invalid": "Die Gesamtzahl der Zimmer muss eine ganze Zahl größer als null sein.",
    "event-create-wizard.address": "Adresse des Veranstaltungsorts",
    "event-create-wizard.basic-description": "Legen Sie jetzt die Grundstruktur der Veranstaltung an. Öffentliche Texte, Grafiken, Preise, Unterkunft und Aktivitäten ergänzen Sie im Arbeitsbereich.",
    "event-create-wizard.create-and-open": "Veranstaltung erstellen",
    "event-create-wizard.created": "Veranstaltung erstellt",
    "event-create-wizard.end-date-after-start": "Das Enddatum muss am oder nach dem Startdatum liegen.",
    "event-create-wizard.event-name": "Name der Veranstaltung",
    "event-create-wizard.fee-choice": "Teilnahmegebühr",
    "event-create-wizard.fee-description": "Gebühr ausgewählt. Zeiträume, Teilnehmertypen und Preise fügen Sie nach dem Erstellen hinzu.",
    "event-create-wizard.fee-no": "Keine Gebühr",
    "event-create-wizard.fee-yes": "Kostenpflichtige Veranstaltung",
    "event-create-wizard.missing-event-id": "Die Veranstaltung wurde erstellt, aber der neue Arbeitsbereich konnte nicht ermittelt werden.",
    "event-create-wizard.no-fee-description": "Keine Gebühr ausgewählt. Für das erste Speichern ist keine Preismatrix nötig.",
    "event-create-wizard.place": "Stadt / Ort",
    "event-create-wizard.title": "Neue Veranstaltung",
    "event-end-date-before-start": "Das Enddatum muss am oder nach dem Startdatum liegen.",
    "event-hotel-created": "Hotel zu dieser Veranstaltung hinzugefügt",
    "event-hotel-linked": "Hotel verknüpft",
    "event-hotel-name-required": "Hotelname ist erforderlich.",
    "event-information-en-required": "Englische Veranstaltungsinformationen sind erforderlich.",
    "event-information-hr-required": "Kroatische Veranstaltungsinformationen sind erforderlich.",
    "event-lifecycle-status:ACTIVE": "Aktiv",
    "event-lifecycle-status:COMPLETED": "Abgeschlossen",
    "event-operational-status.active": "Aktiv",
    "event-operational-status.active.hint": "Bereit für den Veranstaltungsbetrieb.",
    "event-operational-status.completed": "Abgeschlossen",
    "event-operational-status.completed.hint": "Verlauf und Bescheinigungen bleiben verfügbar.",
    "event-operational-status.draft": "Einrichtung im Entwurf",
    "event-operational-status.draft.hint": "Schließen Sie die Einrichtung ab, bevor Sie die Anmeldung teilen.",
    "event-operations-cockpit": "Betriebsübersicht der Veranstaltung",
    "event-option-is-charged": "Ist die Aktivität kostenpflichtig?",
    "event-overview.accommodation-reservations": "Unterkunftsreservierungen",
    "event-overview.active-codes-helper": "{{count}} aktive QR-Codes",
    "event-overview.active-form": "Anmeldelink bereit",
    "event-overview.basics-missing": "Vervollständigen Sie die Grunddaten der Veranstaltung, bevor sich das Team auf diesen Arbeitsbereich verlässt.",
    "event-overview.basics-ready": "Name, Termine und Veranstaltungsdetails sind bereit.",
    "event-overview.certificate-eligible-count": "{{count}} registrierte Teilnehmende",
    "event-overview.certificate-follow-up-description": "Im Teilnehmerdetail finden Sie den Status der QR-Einladung, die Check-in-Berechtigung und Aktionen für Bescheinigungen.",
    "event-overview.certificate-follow-up-title": "QR- und Bescheinigungsbereitschaft prüfen",
    "event-overview.certificate-helper": "Ausstellen und Herunterladen im Teilnehmerdetail",
    "event-overview.certificates-description": "Registrierte Teilnehmende erhalten nach Abschluss der Veranstaltung eine Bescheinigung.",
    "event-overview.certificates-ready-sent": "Bescheinigungen bereit/gesendet",
    "event-overview.check-before-sharing": "Prüfen",
    "event-overview.check-in": "Check-in und QR",
    "event-overview.check-in-description": "Halten Sie QR-Einladungen und den Check-in-Status vor dem Veranstaltungstag im Blick.",
    "event-overview.checked-in-count": "{{count}} eingecheckt",
    "event-overview.fee-disabled": "Deaktiviert",
    "event-overview.form-follow-up-description": "Der gehostete Anmeldelink verwendet die aktuelle Veranstaltungseinrichtung und sollte geprüft werden, bevor ATI ihn teilt.",
    "event-overview.form-follow-up-title": "Freigabe der Anmeldung prüfen",
    "event-overview.form-needed": "Prüfen Sie den Anmeldelink, bevor Sie ihn teilen.",
    "event-overview.form-needed-badge": "Anmeldelink prüfen",
    "event-overview.guided-setup": "Geführte Veranstaltungseinrichtung",
    "event-overview.guided-setup-description": "Schließen Sie die Mindesteinrichtung in der vorgesehenen Reihenfolge ab, bevor Sie die Anmeldung öffnen.",
    "event-overview.invited-count": "{{count}} eingeladen",
    "event-overview.next-actions": "Nächste Schritte",
    "event-overview.next-actions-ready": "Keine akuten Hindernisse",
    "event-overview.next-actions-ready-description": "Der Arbeitsbereich ist abgestimmt. Nutzen Sie Teilnehmende, Rooming und Benachrichtigungen für den laufenden Betrieb.",
    "event-overview.notifications-description": "Prüfen Sie den E-Mail-Verlauf und halten Sie die Nachverfolgung an diese Veranstaltung gebunden.",
    "event-overview.notifications-helper": "Nur E-Mail-Zustellung in v0.1",
    "event-overview.open-accommodation": "Unterkunft öffnen",
    "event-overview.open-certificates": "Teilnehmerdetail öffnen",
    "event-overview.open-check-in": "Teilnehmeraktionen öffnen",
    "event-overview.open-event-basics": "Grunddaten öffnen",
    "event-overview.open-notifications": "Benachrichtigungen öffnen",
    "event-overview.open-participants": "Teilnehmende öffnen",
    "event-overview.open-registration-form": "Anmeldeformular öffnen",
    "event-overview.open-rooming": "Rooming öffnen",
    "event-overview.open-settings": "Einstellungen öffnen",
    "event-overview.paid-fees": "Bezahlte Gebühren",
    "event-overview.participant-count": "{{count}} Teilnehmende",
    "event-overview.participants-description": "Verfolgen Sie Anmeldestatus, Zahlungsstatus von Gebühr und Unterkunft, Angebote, QR-Einladungen und Bescheinigungen in einer Liste.",
    "event-overview.payment-follow-up-description": "Prüfen Sie unbezahlte oder ausstehende Zahlungen im Teilnehmer-Cockpit.",
    "event-overview.payment-follow-up-title": "Offene Zahlungen klären",
    "event-overview.payments": "Zahlungen",
    "event-overview.payments-description": "Prüfen Sie den Zahlungsstatus der Teilnehmenden und die Nachverfolgung der Angebote.",
    "event-overview.payments-follow-up": "{{count}} unbezahlt oder ausstehend",
    "event-overview.payments-helper": "{{count}} unbezahlte oder ausstehende Einträge",
    "event-overview.public-registration": "Öffentliche Anmeldung",
    "event-overview.quick-totals": "Veranstaltungsübersicht",
    "event-overview.registration-count": "{{count}} Anmeldungen",
    "event-overview.registration-form-inactive-helper": "Aktivieren Sie das Basis-Anmeldeformular, bevor Sie den gehosteten Link teilen.",
    "event-overview.registration-link-live-helper": "Der gehostete Anmeldelink ist bereit. Preise, Unterkunft, Aktivitäten und öffentliche Texte werden live aus der Einrichtung übernommen.",
    "event-overview.registration-missing-helper": "Speichern Sie Name, Termine und öffentlichen Text der Veranstaltung, bevor Sie den gehosteten Anmeldelink teilen.",
    "event-overview.registration-payment-helper": "Speichern Sie die Zahlungsmethoden für die Teilnahme, bevor Sie den gehosteten Anmeldelink teilen.",
    "event-overview.registration-ready-helper": "Der gehostete Anmeldelink ist bereit. Änderungen an der Einrichtung erscheinen dort sofort.",
    "event-overview.reservation-count": "{{count}} Reservierungen",
    "event-overview.review-payments": "Zahlungen der Teilnehmenden prüfen",
    "event-overview.room-allotments-missing": "Fügen Sie mindestens ein Zimmerkontingent hinzu, damit die öffentliche Anmeldung echte Zimmer anbietet.",
    "event-overview.room-count": "{{count}} Zimmer",
    "event-overview.rooming": "Rooming",
    "event-overview.rooming-description": "Verwalten Sie Unterkunftsauslastung, reservierte Zimmer, Übernachtungen und Freigaben.",
    "event-overview.rooming-follow-up-description": "Für diese Veranstaltung fehlen noch Hotels, Zimmertypen oder Zimmerkontingente.",
    "event-overview.rooming-follow-up-title": "Rooming-Einrichtung abschließen",
    "event-overview.rooming-helper": "{{count}} Reservierungen",
    "event-overview.rooming-optional": "Optional, sofern die Veranstaltung keine Unterkunft anbietet.",
    "event-overview.rooming-setup": "Rooming-Einrichtung",
    "event-overview.rooming-setup-summary": "{{hotels}} Hotels · {{roomTypes}} Zimmertypen · {{allotments}} Kontingente",
    "event-overview.settings-follow-up-description": "Bestätigen Sie die Grunddaten der Veranstaltung, damit das Team immer den richtigen Kontext sieht.",
    "event-overview.settings-follow-up-title": "Grunddaten der Veranstaltung abschließen",
    "event-overview.setup-accommodation-description": "Hotels, Zimmertypen, Zimmerkontingente, Unterkunftspreise und Zahlungsfristen.",
    "event-overview.setup-activities-description": "Kostenpflichtige oder kostenlose Aktivitäten und Zusatzleistungen in der Anmeldung.",
    "event-overview.setup-activities-optional": "Optional, sofern die Veranstaltung keine wählbaren Aktivitäten oder Zusatzleistungen benötigt.",
    "event-overview.setup-activities-ready": "{{count}} aktive Aktivitäten oder Zusatzleistungen sind für die Anmeldung bereit.",
    "event-overview.setup-pipeline": "Einrichtung prüfen",
    "event-overview.setup-pipeline-description": "Prüfen Sie die Einrichtungsreihenfolge: Grunddaten, Gebühren/Zahlung, Unterkunft, Aktivitäten/Zusatzleistungen und Anmeldeformular.",
    "event-overview.setup-pricing-description": "Gebührenzeiträume, Teilnehmerpreise und aktuelle Gebührenbereitschaft.",
    "event-overview.setup-pricing-fee-off": "Die Teilnahmegebühr ist für diese Veranstaltung deaktiviert. Öffnen Sie diesen Schritt nur, wenn Gebühren erhoben werden sollen.",
    "event-overview.setup-pricing-fee-on": "Diese Veranstaltung erhebt eine Teilnahmegebühr. Speichern Sie aktuelle Preise, bevor Sie die Anmeldung öffnen.",
    "event-overview.setup-registration-description": "Teilen Sie das gehostete Formular, sehen Sie sich die Live-Ansicht an und kopieren Sie den öffentlichen Link oder iframe an einem Ort.",
    "event-overview.setup-settings-description": "Name, Termine, Ort, Adresse, kroatische und englische öffentliche Texte, Grafiken, Grundlagen der Bescheinigung, E-Mail-Standards, Zahlungsmethoden und die Angabe zur Teilnahmegebühr.",
    "event-overview.setup-settings-missing": "Speichern Sie die Grunddaten der Veranstaltung, bevor Sie zu den Preisen übergehen und den gehosteten Anmeldelink teilen.",
    "event-overview.setup-settings-ready": "Die Grunddaten der Veranstaltung sind gespeichert. Nutzen Sie diesen Bereich, wenn Grafiken, die Platzierung auf der Bescheinigung oder öffentliche Texte aktualisiert werden müssen.",
    "event-overview.signals-unavailable": "Veranstaltungsdaten nicht verfügbar",
    "event-overview.total-applications": "Anmeldungen gesamt",
    "event-overview.trend-chart-aria": "Verlauf von Anmeldungen und Reservierungen",
    "event-overview.trend-days": "Tage",
    "event-overview.trend-group-by": "Gruppieren nach",
    "event-overview.trend-last-30-days": "Letzte 30 Tage",
    "event-overview.trend-last-6-months": "Letzte 6 Monate",
    "event-overview.trend-last-7-days": "Letzte 7 Tage",
    "event-overview.trend-months": "Monate",
    "event-overview.trend-period": "Zeitraum",
    "event-overview.trend-registrations": "Anmeldungen",
    "event-overview.trend-reservations": "Reservierungen",
    "event-overview.trend-title": "Veranstaltungsstatus",
    "event-overview.trend-weeks": "Wochen",
    "event-payment-method-required": "Aktivieren Sie für jede Kategorie mindestens eine Zahlungsmethode.",
    "event-payment-methods-saved": "Zahlungsmethoden gespeichert",
    "event-payment-methods-unsaved-defaults-description": "Die Schalter unten zeigen die empfohlenen Standards für Banküberweisung/Karte. Fehlende Kategorien sind im öffentlichen Formular erst verfügbar, wenn Sie die Zahlungsmethoden speichern.",
    "event-payment-methods-unsaved-defaults-title": "Standard-Zahlungsmethoden sind noch nicht gespeichert",
    "event-required": "Veranstaltung auswählen",
    "event-tax-settings-saved": "Steuereinstellungen gespeichert",
    "event-workspace.accommodation": "Unterkunft",
    "event-workspace.active-group": "Aktiv",
    "event-workspace.activities": "Aktivitäten",
    "event-workspace.badge-template": "Akkreditierungen",
    "event-workspace.certificate-template": "Bescheinigungen",
    "event-workspace.check-in": "Check-in",
    "event-workspace.current-group": "Aktuelle Gruppe",
    "event-workspace.current-section": "Aktueller Bereich",
    "event-workspace.current-workflow": "Aktueller Arbeitsablauf",
    "event-workspace.form-linked": "Formular verknüpft",
    "event-workspace.form-needed": "Formular erforderlich",
    "event-workspace.group-operate": "Betrieb",
    "event-workspace.group-selector": "Bereich des Veranstaltungsarbeitsbereichs",
    "event-workspace.group-setup": "Einrichtung",
    "event-workspace.group.operations": "Betrieb",
    "event-workspace.group.setup": "Einrichtung",
    "event-workspace.invalid-event": "Ungültige Veranstaltung",
    "event-workspace.load-error": "Veranstaltungsarbeitsbereich nicht verfügbar",
    "event-workspace.navigation": "Navigation des Veranstaltungsarbeitsbereichs",
    "event-workspace.not-found": "Veranstaltung nicht gefunden.",
    "event-workspace.open": "Öffnen",
    "event-workspace.overview": "Übersicht",
    "event-workspace.registration-fees": "Gebühren und Zahlung",
    "event-workspace.registration-form": "Formular",
    "event-workspace.rooming": "Reservierungen",
    "event-workspace.section-selector": "Bereich im Veranstaltungsarbeitsbereich",
    "event-workspace.settings": "Grunddaten",
    "event-workspace.setup": "Einrichtung",
    "event-workspace.status-labels": "Statusangaben der Veranstaltung",
    "event-workspace.workspace": "Veranstaltungsarbeitsbereich",
    "events-page.activate-confirm-description": "Die Veranstaltung wird betriebsbereit. Für die öffentliche Anmeldung ist weiterhin ein aktives Anmeldeformular erforderlich.",
    "events-page.activate-confirm-title": "Diese Veranstaltung als aktiv markieren?",
    "events-page.activated": "Veranstaltung als aktiv markiert",
    "events-page.active-count": "{{count}} Veranstaltungen",
    "events-page.active-error": "Veranstaltungen nicht verfügbar",
    "events-page.active-error-description": "Aktualisieren Sie die Liste oder versuchen Sie es später erneut.",
    "events-page.active-title": "Auswählbare Veranstaltungen",
    "events-page.archive-action": "Veranstaltung archivieren",
    "events-page.archive-confirm-description": "Diese Veranstaltung verlässt die aktive Auswahl und bleibt im Archiv und im Verlauf verfügbar.",
    "events-page.archive-confirm-title": "Diese Veranstaltung archivieren?",
    "events-page.archive-error": "Archiv nicht verfügbar",
    "events-page.archive-error-description": "Aktualisieren Sie das Archiv oder versuchen Sie es später erneut.",
    "events-page.archive-title": "Archiv",
    "events-page.archived": "Veranstaltung archiviert",
    "events-page.choose-event": "Wählen Sie zuerst die Veranstaltung",
    "events-page.choose-event-help": "Einrichtung, Teilnehmende, Rooming und Benachrichtigungen öffnen sich im Arbeitsbereich der ausgewählten Veranstaltung.",
    "events-page.complete-confirm-description": "Die Veranstaltung bleibt hier verfügbar, und für abgeschlossene Abläufe können Bescheinigungen erstellt werden.",
    "events-page.complete-confirm-title": "Diese Veranstaltung als abgeschlossen markieren?",
    "events-page.completed": "Veranstaltung als abgeschlossen markiert",
    "events-page.completed-ready": "Bereit für Bescheinigungen",
    "events-page.duplicate": "Duplizieren",
    "events-page.duplicate-missing-event-id": "Die duplizierte Veranstaltung wurde erstellt, aber der neue Arbeitsbereich konnte nicht geöffnet werden.",
    "events-page.duplicated": "Veranstaltung dupliziert",
    "events-page.empty-active": "Noch keine Veranstaltungen zur Auswahl bereit.",
    "events-page.empty-archive": "Noch keine archivierten Veranstaltungen.",
    "events-page.mark-active": "Als aktiv markieren",
    "events-page.mark-complete": "Als abgeschlossen markieren",
    "events-page.no-search-results": "Keine Veranstaltungen entsprechen dieser Suche.",
    "events-page.reactivate": "Reaktivieren",
    "events-page.reactivate-confirm-description": "Die Veranstaltung kehrt in den aktiven Betrieb zurück, und die öffentliche Anmeldung kann wieder verfügbar werden.",
    "events-page.reactivate-confirm-title": "Diese Veranstaltung reaktivieren?",
    "events-page.reactivated": "Veranstaltung wieder aktiv",
    "events-page.restore": "Wiederherstellen",
    "events-page.restored": "Veranstaltung wiederhergestellt",
    "events-page.search-placeholder": "Veranstaltungen suchen",
    "export": "Exportieren",
    "exported-by": "Exportiert von",
    "failed-timeline": "Fehlgeschlagen: {{value}}",
    "fee": "Teilnahmegebühr",
    "fee-payment": "Zahlung der Teilnahmegebühr",
    "fee-prices": "Gebührenpreise",
    "fee-prices-helper": "Gebührenpreise verbinden Gebührenarten mit Früh-, Normal- und Spätbucher-Zeiträumen.",
    "fee-type": "Gebührenart",
    "fee-type-public-hidden": "Im öffentlichen Formular ausgeblendet",
    "fee-type-requires-proof": "Nachweis erforderlich",
    "fee-types": "Gebührenarten",
    "feeTypeId": "Gebührenart",
    "file": "Datei",
    "file-not-selected": "Keine Datei ausgewählt",
    "file-uploaded": "Datei hochgeladen",
    "first-name": "Vorname",
    "forgot-password": "Passwort vergessen?",
    "form.error": "Fehler",
    "free": "Kostenlos",
    "full-name": "Name",
    "general-settings-saved": "Allgemeine Einstellungen gespeichert",
    "generate": "Erstellen",
    "generate-certificate": "Bescheinigung erstellen",
    "generated": "Erstellt",
    "global-settings": "Globale Einstellungen",
    "gross": "Brutto",
    "gross-total": "Bruttosumme",
    "history": "Verlauf",
    "hotel": "Hotel",
    "hotel-name": "Hotelname",
    "hotel-unavailable": "Hotel nicht verfügbar",
    "hotels": "Hotels",
    "hotels-cancel": "Abbrechen",
    "hotels-category-not-selected": "Nicht ausgewählt",
    "hotels-category-select": "Hotelkategorie auswählen",
    "hotels-category-stars": "Hotelkategorie: {{count}} von 5 Sternen",
    "hotels-delete": "Löschen",
    "hotels-delete-confirm": "Dieses Hotel aus dem globalen Katalog löschen?",
    "hotels-delete-failed": "Hotel konnte nicht gelöscht werden.",
    "hotels-deleted": "Hotel gelöscht.",
    "hotels-description": "Globaler Hotelkatalog",
    "hotels-field-address": "Adresse",
    "hotels-field-category": "Kategorie",
    "hotels-field-city": "Stadt",
    "hotels-field-country": "Land",
    "hotels-field-name": "Name",
    "hotels-field-notes": "Notizen",
    "hotels-in-use": "Dieses Hotel ist mit einer Veranstaltung verknüpft und kann nicht gelöscht werden. Entfernen Sie zuerst die Verknüpfungen in den Veranstaltungseinstellungen.",
    "hotels-name-required": "Geben Sie den Hotelnamen ein.",
    "hotels-new": "Neues Hotel",
    "hotels-not-found": "Hotel nicht gefunden.",
    "hotels-retry": "Erneut versuchen",
    "hotels-save": "Speichern",
    "hotels-save-failed": "Hotel konnte nicht gespeichert werden.",
    "hotels-saved": "Hotel gespeichert.",
    "hotels-search": "Nach Name, Stadt oder Land suchen",
    "hotels-shared-info": "Änderungen an den Hoteldaten gelten für alle Veranstaltungen, die dieses Hotel verwenden.",
    "iban": "IBAN",
    "inactive": "Inaktiv",
    "institution-company": "Institution/Unternehmen",
    "invitation-check-in": "Einladungen und Check-in",
    "invitation-check-in-summary-unavailable": "Übersicht zu Einladungen und Check-in nicht verfügbar",
    "invited": "Eingeladen",
    "issued": "Ausgestellt",
    "label-en": "Bezeichnung (Englisch)",
    "label-hr": "Bezeichnung (Kroatisch)",
    "labelEn": "Bezeichnung (Englisch)",
    "labelHr": "Bezeichnung (Kroatisch)",
    "language": "Sprache",
    "last-name": "Nachname",
    "lifecycle-status": "Lebenszyklusstatus",
    "list-search": "Liste durchsuchen",
    "logo": "Logo",
    "mail-first-template-helper": "E-Mail als primärer Kanal",
    "manual": "Manuell",
    "manual-reconcile-failed": "Die Zahlung konnte nicht als abgeglichen markiert werden.",
    "manual-reconcile-note-prompt": "Geben Sie einen Abgleichshinweis ein.",
    "manual-reconcile-note-required": "Ein Abgleichshinweis ist erforderlich.",
    "manual-reconcile-success": "Zahlung als abgeglichen markiert.",
    "manual-reconciliation-note": "Hinweis zum manuellen Abgleich",
    "mark-reconciled": "Als abgeglichen markieren",
    "missing": "Fehlt",
    "more-lines": "weitere Positionen",
    "name-en-required": "Englischer Name ist erforderlich.",
    "name-hr-required": "Kroatischer Name ist erforderlich.",
    "name-required": "Name ist erforderlich.",
    "net": "Netto",
    "new-password": "Neues Passwort",
    "new-password-min-length": "Verwenden Sie mindestens {{count}} Zeichen.",
    "new-password-required": "Neues Passwort ist erforderlich.",
    "new-payer": "Neuer Zahler",
    "nights": "Nächte",
    "no-accommodation-offer": "Keines",
    "no-certificates": "Keine Bescheinigungen",
    "no-company": "Kein Unternehmen",
    "no-event-selected": "Keine Veranstaltung ausgewählt.",
    "no-fee-offer": "Keines",
    "no-filter-options": "Keine Optionen",
    "no-offer": "Keines",
    "no-payment-allocations": "Keine Zahlungszuordnungen",
    "no-registration": "Keine",
    "no-registration-codes": "Keine Anmeldecodes",
    "no-reservation": "Keine",
    "no-rooming-registrations-found": "Für diese Veranstaltung wurden keine Unterkunftsreservierungen gefunden.",
    "no-stored-offers": "Keine gespeicherten Angebote",
    "no-subject": "Kein Betreff",
    "not-authorized": "Nicht berechtigt",
    "not-available": "Nicht verfügbar",
    "not-eligible": "Nicht bereit",
    "not-verified": "Unbestätigt",
    "notification-channel": "Benachrichtigungskanal",
    "notification-channel-application": "Anwendung",
    "notification-channel-email": "E-Mail",
    "notification-channel-unknown": "Kanal nicht erfasst",
    "notification-delivery-failed-generic": "Zustellung der Benachrichtigung fehlgeschlagen.",
    "notification-delivery-multiple-failures": "{{count}} fehlgeschlagene Zustellungen. Öffnen Sie die Empfänger für Details.",
    "notification-delivery-ok": "Kein Zustellfehler erfasst.",
    "notification-no-message-preview": "Kein Inhalt erfasst",
    "notification-recipient": "Empfänger",
    "notification-without-template": "Ohne Vorlage",
    "notifications-add-filtered-recipients": "Alle gefilterten hinzufügen",
    "notifications-clear-recipients": "Auswahl aufheben",
    "notifications-compose-description": "Wählen Sie einen Benachrichtigungskanal, verwenden Sie optional eine Vorlage und senden Sie eine Nachricht an ausgewählte Teilnehmende.",
    "notifications-compose-title": "Veranstaltungsbenachrichtigung senden",
    "notifications-draft-loaded-success": "Entwurf in das Formular geladen.",
    "notifications-draft-missing-recipients-description": "Die folgenden Empfänger aus dem gespeicherten Entwurf existieren nicht mehr. Bestätigen Sie, um sie aus der Auswahl zu entfernen.",
    "notifications-draft-missing-recipients-title": "Einige Empfänger sind nicht mehr verfügbar",
    "notifications-draft-recipients-loading": "Warten Sie, bis die Empfängerliste geladen ist.",
    "notifications-draft-recipients-unavailable": "Der Entwurf kann nicht geladen werden, solange die Empfängerliste nicht verfügbar ist.",
    "notifications-draft-save-failed": "Der Benachrichtigungsentwurf konnte nicht gespeichert werden.",
    "notifications-draft-save-success": "Benachrichtigungsentwurf gespeichert.",
    "notifications-draft-save-success-count": "Benachrichtigungsentwurf für {{count}} Empfänger gespeichert.",
    "notifications-error": "Benachrichtigungen sind derzeit nicht verfügbar.",
    "notifications-footer": "Fußzeile",
    "notifications-footer-placeholder": "Wählen Sie eine Vorlage oder geben Sie die Fußzeile der Benachrichtigung ein.",
    "notifications-header": "Kopfzeile",
    "notifications-header-placeholder": "Wählen Sie eine Vorlage oder geben Sie die Kopfzeile der Benachrichtigung ein.",
    "notifications-load-draft": "Entwurf laden",
    "notifications-message": "Nachricht",
    "notifications-message-placeholder": "Geben Sie die Nachricht an die Empfänger ein.",
    "notifications-no-participation-fee-type": "Keine Teilnahmegebührenart",
    "notifications-no-recipients": "Für diese Veranstaltung sind noch keine Teilnehmenden für Benachrichtigungen verfügbar.",
    "notifications-no-templates": "Fügen Sie eine E-Mail-Vorlage der Veranstaltung hinzu, bevor Sie Benachrichtigungen senden.",
    "notifications-open-recipient-picker": "Empfänger auswählen",
    "notifications-recipient-count": "{{count}} Empfänger",
    "notifications-recipient-details-search": "Empfänger suchen",
    "notifications-recipient-details-search-count": "{{shown}} von {{total}} Empfängern",
    "notifications-recipient-details-search-empty": "Keine Empfänger entsprechen der Suche.",
    "notifications-recipient-details-search-placeholder": "Nach E-Mail, Status oder Zustellung suchen",
    "notifications-recipient-filter-all-companies": "Alle Unternehmen",
    "notifications-recipient-filter-all-fee-types": "Alle Teilnahmegebührenarten",
    "notifications-recipient-filter-all-statuses": "Alle Status",
    "notifications-recipient-picker-count": "{{filtered}} angezeigt, {{selected}} ausgewählt",
    "notifications-recipient-picker-title": "Empfängerauswahl",
    "notifications-recipient-registration-id": "Anmeldung {{id}}",
    "notifications-recipient-search": "Empfänger suchen",
    "notifications-recipient-search-placeholder": "Name, E-Mail, Unternehmen, Telefon...",
    "notifications-recipients": "Empfänger",
    "notifications-recipients-button": "Empfänger",
    "notifications-recipients-error-title": "Empfänger sind nicht verfügbar",
    "notifications-reply-to-addresses": "Reply-To-Adressen",
    "notifications-reply-to-enabled": "Reply-To-Adresse verwenden",
    "notifications-reply-to-placeholder": "Reply-To-Adressen eingeben",
    "notifications-retry-failed": "Fehlgeschlagene erneut senden",
    "notifications-retry-queued-success": "Erneuter Versand für {{count}} Empfänger eingeplant.",
    "notifications-save-draft": "Entwurf speichern",
    "notifications-save-recipient-selection": "Auswahl speichern",
    "notifications-select-all-recipients": "Alle Empfänger auswählen",
    "notifications-select-channel": "Benachrichtigungskanal auswählen",
    "notifications-select-recipients": "Teilnehmende für diese Benachrichtigung auswählen",
    "notifications-select-template": "Vorlage auswählen (optional)",
    "notifications-selected-count": "Ausgewählte Empfänger: {{selected}}",
    "notifications-send": "Benachrichtigung senden",
    "notifications-send-failed-count": "Es konnte keine Benachrichtigung in die Warteschlange gestellt werden. {{failedCount}} fehlgeschlagen. Details finden Sie im Verlauf.",
    "notifications-send-partial-count": "{{sentCount}} Benachrichtigungen in der Warteschlange. {{failedCount}} konnten nicht eingereiht werden. Details finden Sie im Verlauf.",
    "notifications-send-queued-count": "{{count}} Benachrichtigungen in der Warteschlange.",
    "notifications-send-queued-partial-count": "{{queuedCount}} Benachrichtigungen in der Warteschlange. {{failedCount}} konnten nicht eingereiht werden. Details finden Sie im Verlauf.",
    "notifications-send-success": "Benachrichtigungen in der Warteschlange.",
    "notifications-send-success-count": "{{count}} Benachrichtigungen in der Warteschlange.",
    "notifications-template-subject-placeholder": "Betreff der Benachrichtigung eingeben.",
    "notifications-templates-error-title": "E-Mail-Vorlagen sind nicht verfügbar",
    "offer": "Angebot",
    "offer-document": "Angebotsdokument",
    "offer-history": "Angebotsverlauf",
    "offer-id": "Angebots-ID",
    "offer-number-value": "Angebot {{offerNumber}}",
    "offer-pdf": "Angebot als PDF",
    "offer-resend-failed": "Die Angebots-E-Mail konnte nicht gesendet werden",
    "offer-resend-queued": "Angebots-E-Mail in der Warteschlange.",
    "offer-resend-success": "Angebots-E-Mail gesendet",
    "offer-state": "Angebotsstatus",
    "oib": "OIB",
    "ok": "OK",
    "on-site-flow-copy": "Hinweise vor Ort und zum Check-in",
    "on-site-registration-instructions-en-required": "Englische Hinweise für die Anmeldung vor Ort sind erforderlich.",
    "on-site-registration-instructions-hr-required": "Kroatische Hinweise für die Anmeldung vor Ort sind erforderlich.",
    "onboarding-email-failed": "Fehlgeschlagen",
    "onboarding-email-resent": "Erneut gesendet",
    "onboarding-email-sent": "Gesendet",
    "open": "Öffnen",
    "open-cockpit": "Detail öffnen",
    "open-color-picker": "Farbauswahl öffnen",
    "open-participant-cockpit": "Teilnehmerdetail öffnen",
    "open-payer": "Zahler öffnen",
    "operational-status": "Betriebsstatus",
    "operational-status-before-archive": "Betriebsstatus vor der Archivierung",
    "operator-state": "Betriebsstatus",
    "organization-member-created-email-failed": "Organisationsmitglied erstellt, aber die Onboarding-E-Mail ist fehlgeschlagen. Prüfen Sie die SMTP-Einstellungen und senden Sie das Onboarding erneut.",
    "organization-member-created-email-queued": "Organisationsmitglied erstellt; Onboarding-E-Mail in der Warteschlange.",
    "organization-member-deactivate-confirm": "Dieses Organisationsmitglied deaktivieren?",
    "organization-member-deactivated": "Organisationsmitglied deaktiviert",
    "organization-member-invite-removed": "Ausstehende Einladung entfernt",
    "organization-member-onboarding-email-failed": "Onboarding-E-Mail fehlgeschlagen. Prüfen Sie die SMTP-Einstellungen und senden Sie das Onboarding erneut.",
    "organization-member-onboarding-help": "Wählen Sie Ihr Passwort, um die Einladung zu bestätigen.",
    "organization-member-onboarding-invalid": "Dieser Onboarding-Link ist ungültig oder abgelaufen.",
    "organization-member-onboarding-invalid-title": "Onboarding-Link kann nicht verwendet werden",
    "organization-member-onboarding-queued": "Onboarding-E-Mail in der Warteschlange.",
    "organization-member-onboarding-submit": "Passwort festlegen",
    "organization-member-onboarding-title": "Veranstalterkonto einrichten",
    "organization-member-reactivate-confirm": "Dieses Organisationsmitglied reaktivieren?",
    "organization-member-reactivated": "Organisationsmitglied reaktiviert",
    "organization-member-remove-invite": "Einladung entfernen",
    "organization-member-updated": "Organisationsmitglied aktualisiert",
    "organizer-email": "E-Mail des Veranstalters",
    "organizer-email-required": "E-Mail des Veranstalters ist erforderlich.",
    "organizer-password-recovery": "Passwort-Wiederherstellung für Veranstalter",
    "organizer-password-recovery-help": "Verwenden Sie Ihre Veranstalter-E-Mail-Adresse, um Ihr Passwort zurückzusetzen. Administratoren können Veranstalterpasswörter weder vergeben noch einsehen.",
    "organizer-password-recovery-submit": "Anleitung senden",
    "organizer-password-reset-complete-help": "Melden Sie sich mit Ihrem neuen Veranstalterpasswort an.",
    "organizer-password-reset-help": "Geben Sie ein neues Passwort für Ihr Veranstalterkonto ein.",
    "organizer-password-reset-invalid": "Dieser Link zum Zurücksetzen des Passworts ist ungültig oder abgelaufen. Fordern Sie einen neuen Link an.",
    "organizer-password-reset-invalid-title": "Link zum Zurücksetzen kann nicht verwendet werden",
    "organizer-password-reset-submit": "Neues Passwort festlegen",
    "organizer-password-reset-title": "Neues Passwort wählen",
    "organizerEmail": "E-Mail des Veranstalters",
    "organizerPhone": "Telefon des Veranstalters",
    "participant-accommodation-empty": "Für diese Veranstaltung sind keine Unterkunftszeiträume festgelegt.",
    "participant-accommodation-load-failed": "Die Unterkunft konnte nicht geladen werden. Aktualisieren Sie die Seite und versuchen Sie es erneut.",
    "participant-actions": "Aktionen für Teilnehmende",
    "participant-activities-empty": "Keine Aktivitäten zum Anzeigen verfügbar.",
    "participant-activities-locked-after-offer": "Aktivitäten werden vor der Erstellung des Teilnahmeangebots bearbeitet.",
    "participant-activities-save-failed": "Die Aktivitäten der teilnehmenden Person konnten nicht gespeichert werden.",
    "participant-activities-save-success": "Aktivitäten der teilnehmenden Person gespeichert.",
    "participant-and-event": "Teilnehmende Person / Veranstaltung",
    "participant-basics-title": "Teilnehmerdaten",
    "participant-cockpit.actions-helper": "Angebote, Zahlungen, QR und Bescheinigungen",
    "participant-cockpit.subtitle": "Steuern Sie Anmeldung, Zahlungen, Angebote, QR und Bescheinigungen aus einer Veranstaltungsliste.",
    "participant-delete-confirm": "Teilnehmende Person löschen?",
    "participant-delete-confirm-description": "{{participant}} wird aus der Veranstaltung entfernt.",
    "participant-delete-failed": "Die teilnehmende Person konnte nicht gelöscht werden.",
    "participant-delete-success": "Teilnehmende Person gelöscht.",
    "participant-detail": "Teilnehmerdetail",
    "participant-detail-partial-description": "Die Grunddaten sind geladen, aber Betriebsdetails zu Anmeldungen, Angeboten und QR-Status sind für diesen Eintrag derzeit nicht verfügbar.",
    "participant-detail-partial-title": "Teilnehmerdaten sind teilweise verfügbar",
    "participant-detail.invalid": "Ungültige Route zum Teilnehmerdetail.",
    "participant-export-history": "Verlauf der Teilnehmer-CSV-Exporte",
    "participant-export-minimal-fields": "Veranstaltungs-ID, E-Mail, Status, Zahlung, Bescheinigung",
    "participant-name-unavailable": "Name der teilnehmenden Person nicht verfügbar",
    "participant-note": "Hinweis",
    "participant-page-subtitle": "Teilnehmerdaten, Zahler, Unterkunft und Aktivitäten.",
    "participant-page-title": "Teilnehmende Person – {{participantFullName}}",
    "participant-register": "Anmelden",
    "participant-register-active-form-required": "Erstellen und aktivieren Sie vor der Anmeldung einer teilnehmenden Person ein öffentliches Anmeldeformular im Reiter Formular der Veranstaltung.",
    "participant-register-already-exists": "Die teilnehmende Person ist bereits für diese Veranstaltung angemeldet.",
    "participant-register-before-accommodation": "Melden Sie die teilnehmende Person zuerst an, damit die Unterkunft in der Anmeldung gespeichert werden kann.",
    "participant-register-before-activities": "Melden Sie die teilnehmende Person zuerst an, damit Aktivitäten in der Anmeldung gespeichert werden können.",
    "participant-register-failed": "Die teilnehmende Person konnte nicht für die Veranstaltung angemeldet werden.",
    "participant-register-missing-company": "Institution / Unternehmen",
    "participant-register-missing-email": "E-Mail der teilnehmenden Person",
    "participant-register-missing-first-name": "Vorname der teilnehmenden Person",
    "participant-register-missing-last-name": "Nachname der teilnehmenden Person",
    "participant-register-missing-payer": "Zahler",
    "participant-register-missing-payer-address": "Adresse des Zahlers",
    "participant-register-missing-payer-city": "Stadt des Zahlers",
    "participant-register-missing-payer-contact": "Ansprechperson des Zahlers",
    "participant-register-missing-payer-country": "Land des Zahlers",
    "participant-register-missing-payer-email": "E-Mail des Zahlers",
    "participant-register-missing-payer-name": "Name / Person des Zahlers",
    "participant-register-missing-payer-phone": "Telefon des Zahlers",
    "participant-register-missing-payer-tax-id": "OIB des Zahlers",
    "participant-register-missing-phone": "Telefon der teilnehmenden Person",
    "participant-register-success": "Die teilnehmende Person ist für die Veranstaltung angemeldet.",
    "participant-register-validation-title": "Ergänzen Sie vor der Anmeldung die Pflichtangaben.",
    "participant-registration-save-failed": "Anmeldedaten konnten nicht gespeichert werden.",
    "participant-registration-save-success": "Anmeldedaten gespeichert.",
    "participant-rejection-failed": "Die Anmeldung konnte nicht abgelehnt werden.",
    "participant-rejection-reason-prompt": "Geben Sie den Grund für die Ablehnung dieser Anmeldung ein.",
    "participant-rejection-reason-required": "Ein Ablehnungsgrund ist erforderlich.",
    "participant-rejection-success": "Anmeldung abgelehnt.",
    "participant-room-reservation-missing-dates": "Geben Sie An- und Abreisedatum ein.",
    "participant-room-reservation-missing-room": "Wählen Sie ein Hotel und einen Zimmertyp.",
    "participant-room-reservation-missing-room-count": "Geben Sie die Anzahl der Zimmer ein.",
    "participant-room-reservation-save-failed": "Die Unterkunftsreservierung konnte nicht gespeichert werden.",
    "participant-room-reservation-save-success": "Unterkunftsreservierung gespeichert.",
    "participant-save-failed": "Teilnehmerdaten konnten nicht gespeichert werden.",
    "participant-save-success": "Teilnehmerdaten gespeichert.",
    "participant-search": "Teilnehmende suchen",
    "participant-type-proof": "Nachweis zur Teilnehmerart",
    "participants.bulk.certificates-helper": "{{count}} Teilnehmende ausgewählt. Bescheinigungen sind im Teilnehmerdetail verfügbar.",
    "participants.bulk.delete": "Auswahl löschen",
    "participants.bulk.delete-confirm": "Ausgewählte Teilnehmende ({{count}}) löschen?",
    "participants.bulk.delete-failed-count": "Nicht gelöscht: {{count}} Teilnehmende.",
    "participants.bulk.deleted-count": "Gelöscht: {{count}} Teilnehmende.",
    "participants.bulk.export-csv": "CSV exportieren",
    "participants.bulk.export-csv-error": "CSV-Export fehlgeschlagen. Versuchen Sie es erneut.",
    "participants.bulk.export-csv-success": "CSV-Export heruntergeladen.",
    "participants.bulk.offers-helper": "{{count}} Teilnehmende ausgewählt. Senden Sie Angebote aus dem Teilnehmerdetail (Detail öffnen).",
    "participants.bulk.select-first": "Wählen Sie mindestens eine teilnehmende Person aus.",
    "participants.bulk.send-certificates": "Bescheinigungen senden",
    "participants.bulk.send-offer": "Angebot senden",
    "participants.filter-result-summary": "{{shown}} von {{total}} Teilnehmenden",
    "participants.filters": "Teilnehmerfilter",
    "participants.search-placeholder": "Name, Unternehmen oder E-Mail",
    "participation-fee-type": "Teilnahmegebührenart",
    "participation-offer": "Teilnahmeangebot",
    "participation-offer-renew-failed": "Das Ersatzangebot konnte nicht gesendet werden.",
    "participation-offer-renew-success": "Ersatzangebot gesendet.",
    "password-recovery-requested-title": "Prüfen Sie Ihre E-Mails",
    "password-recovery-success-help": "Falls dieses Veranstalterkonto existiert, wurde eine Anleitung zur Passwort-Wiederherstellung gesendet.",
    "passwords-do-not-match": "Die Passwörter stimmen nicht überein.",
    "payee-address": "Adresse des Zahlungsempfängers",
    "payee-address-required": "Adresse des Zahlungsempfängers ist erforderlich.",
    "payee-iban-required": "IBAN ist erforderlich.",
    "payee-name-required": "Name des Unternehmens/Zahlungsempfängers ist erforderlich.",
    "payee-oib-required": "OIB ist erforderlich.",
    "payer-address": "Adresse des Zahlers",
    "payer-city": "Stadt des Zahlers",
    "payer-contact-person": "Ansprechperson",
    "payer-country": "Land des Zahlers",
    "payer-create": "Zahler hinzufügen",
    "payer-create-success": "Zahler hinzugefügt.",
    "payer-delete-failed": "Der Zahler konnte nicht gelöscht werden.",
    "payer-delete-success": "Zahler gelöscht.",
    "payer-edit": "Zahler bearbeiten",
    "payer-email": "E-Mail des Zahlers",
    "payer-name": "Name / Person",
    "payer-phone": "Telefon des Zahlers",
    "payer-save-failed": "Der Zahler konnte nicht gespeichert werden.",
    "payer-save-success": "Zahler gespeichert.",
    "payer-search-placeholder": "Nach Name, E-Mail oder OIB suchen",
    "payer-tax-id": "OIB des Zahlers",
    "payer-type": "Zahlerart",
    "payer-type-company": "Unternehmen",
    "payer-type-individual": "Privatperson",
    "payer-type-sponsor": "Sponsor",
    "payers": "Zahler",
    "payers-description": "Globalen Zahlerkatalog durchsuchen und bearbeiten.",
    "payment-allocation": "Zahlungszuordnung",
    "payment-deadline": "Zahlungsfrist",
    "payment-entry-amount": "Erhaltener Betrag",
    "payment-entry-bank": "Banküberweisung",
    "payment-entry-cash": "Bargeld",
    "payment-entry-close": "Schließen",
    "payment-entry-date": "Zahlungsdatum",
    "payment-entry-failed": "Zahlung konnte nicht gespeichert werden.",
    "payment-entry-help": "Erfassen Sie eine tatsächlich erhaltene Zahlung. Der Betrag wird dem ausgewählten Angebot zugeordnet und als manuell abgeglichen markiert. Teilzahlungen sind zulässig; der Betrag darf den Restbetrag nicht übersteigen.",
    "payment-entry-method": "Zahlungsmethode",
    "payment-entry-no-offers": "Für diesen Zahler sind keine aktuellen Angebote mit offenem Betrag verfügbar.",
    "payment-entry-note": "Hinweis / Bestätigungsgrundlage",
    "payment-entry-offer": "Angebot",
    "payment-entry-offer-total": "Angebotssumme",
    "payment-entry-positive": "Geben Sie einen Betrag größer als null ein.",
    "payment-entry-reference": "Zahlungsreferenz",
    "payment-entry-refresh-failed": "Die Zahlung wurde gespeichert, aber die Liste konnte nicht aktualisiert werden. Schließen Sie diesen Dialog und aktualisieren Sie die Seite. Erfassen Sie diese Zahlung nicht erneut.",
    "payment-entry-required": "Pflichtfeld.",
    "payment-entry-save": "Zahlung speichern",
    "payment-entry-sponsor": "Sponsor",
    "payment-entry-title": "Zahlung erfassen",
    "payment-method-bank-transfer": "Banküberweisung",
    "payment-method-card": "Karte (Stripe)",
    "payment-method-category-accommodation": "Unterkunft",
    "payment-method-category-accommodation-description": "Für Angebote zu Hotel- und Zimmerreservierungen.",
    "payment-method-category-participation": "Teilnahme und Optionen",
    "payment-method-category-participation-description": "Für Teilnahmegebühren und kostenpflichtige Anmeldeoptionen.",
    "payment-method-pos": "POS",
    "payment-methods": "Zahlungsmethoden",
    "payment-reconciliation": "Zahlungsabgleich",
    "payment-records": "Zahlungseinträge",
    "payment-reference-value": "Referenz {{reference}}",
    "payment-state": "Zahlungsstatus",
    "payment-status": "Zahlungsstatus",
    "payment-total": "Zahlungen gesamt",
    "pending": "Ausstehend",
    "period": "Zeitraum",
    "persisted-settings": "Gespeichert",
    "phone": "Telefon",
    "place-required": "Ort ist erforderlich.",
    "preview": "Vorschau",
    "price": "Preis",
    "price-effect": "Preiswirkung",
    "price-per-night": "Preis pro Nacht",
    "pricing-periods": "Preiszeiträume",
    "privacy-consent-event-id": "Veranstaltungs-ID der Einwilligung",
    "privacy-consent-missing": "Fehlt",
    "privacy-consent-recorded": "Erfasst",
    "privacy-consent-version": "Version",
    "profile": "Profil",
    "profile-error": "Das Profil ist derzeit nicht verfügbar.",
    "profile-load-error-title": "Profil nicht verfügbar",
    "profile-save-success": "Profil gespeichert.",
    "provider": "Anbieter",
    "provider-reference": "Referenz des Anbieters",
    "public-asset-mode": "Format der öffentlichen Anhänge",
    "public-event-forms.activate-basic": "Basisformular aktivieren",
    "public-event-forms.activation-description": "Aktivieren Sie ein Basisformular, um öffentliche Anmeldungen anzunehmen.",
    "public-event-forms.activation-failed": "Das Anmeldeformular konnte nicht aktiviert werden.",
    "public-event-forms.activation-settings-required": "Ergänzen Sie Name, Termine und öffentlichen Text der Veranstaltung, bevor Sie Anmeldungen aktivieren.",
    "public-event-forms.activation-success": "Das Anmeldeformular ist aktiv.",
    "public-event-forms.explainer-active": "Die gehostete URL verwendet immer die aktuelle Veranstaltungseinrichtung.",
    "public-event-forms.explainer-live-setup": "Preise, Zahlungsmethoden, Unterkunft, Zimmerverfügbarkeit, Aktivitäten und öffentliche Texte werden live aus der Einrichtung übernommen.",
    "public-event-forms.explainer-title": "Was das öffentliche Formular verwendet",
    "public-event-forms.readiness-activation-needed": "Erstellen und aktivieren Sie das Basisformular, bevor Sie den gehosteten Link teilen.",
    "public-event-forms.readiness-basics-needed": "Speichern Sie Name, Termine und öffentlichen Text der Veranstaltung in den Einstellungen, bevor Sie den gehosteten Link teilen.",
    "public-event-forms.readiness-check-failed": "Der Status des Anmeldeformulars konnte nicht geprüft werden. Versuchen Sie es erneut, bevor Sie den Link teilen.",
    "public-event-forms.readiness-checking": "Wird geprüft",
    "public-event-forms.readiness-checking-description": "Es wird geprüft, ob diese Veranstaltung ein aktives öffentliches Anmeldeformular hat.",
    "public-event-forms.readiness-inactive": "Inaktiv",
    "public-event-forms.readiness-options-optional": "Aktivitäten und Zusatzleistungen sind optional und erscheinen nur, wenn sie aktiviert sind.",
    "public-event-forms.readiness-options-ready": "{{count}} aktive Aktivitäten oder Zusatzleistungen erscheinen bereits im öffentlichen Formular.",
    "public-event-forms.readiness-payment-needed": "Speichern Sie die Zahlungsmethoden für die Teilnahme in den Veranstaltungseinstellungen, bevor Sie den gehosteten Link teilen.",
    "public-event-forms.readiness-rooming-optional": "Die Unterkunft ist optional. Das öffentliche Formular bleibt einfacher, bis Zimmer eingerichtet sind.",
    "public-event-forms.readiness-rooming-ready": "{{hotels}} Hotels, {{roomTypes}} Zimmertypen und {{allotments}} Kontingente sind für die Anmeldung aktiv.",
    "public-event-forms.readiness-rooming-review": "Die Unterkunft ist sichtbar, aber schließen Sie Hotels, Zimmertypen und Zimmerkontingente ab, bevor Sie das Zimmerangebot teilen.",
    "public-event-forms.readiness-share-ready": "Der gehostete Anmeldelink ist bereit. Änderungen an der Einrichtung erscheinen dort sofort.",
    "public-invitation-company": "Unternehmen",
    "public-invitation-dates": "Termine",
    "public-invitation-error-help": "Prüfen Sie, ob Sie den vollständigen Link aus Ihrer E-Mail geöffnet haben, oder wenden Sie sich an den Veranstalter.",
    "public-invitation-help": "Zeigen Sie den QR-Code aus Ihrer E-Mail am Registrierungsschalter. Das Öffnen dieser Seite ändert Ihren Anmeldestatus nicht.",
    "public-registration-details-title": "Anmeldedetails",
    "public-registration-details-help": "Ihre QR-Einladung erhalten Sie per E-Mail, sobald der Veranstalter Sie einlädt; zeigen Sie sie am Registrierungsschalter. Das Öffnen dieser Seite ändert Ihren Anmeldestatus nicht.",
    "public-invitation-invalid": "Dieser Einladungslink ist ungültig oder nicht mehr aktiv.",
    "public-invitation-loading": "Ihre Einladung wird geprüft",
    "public-invitation-location": "Ort",
    "public-invitation-on-site-instructions": "Hinweise vor Ort",
    "public-invitation-participant": "Teilnehmende Person",
    "public-invitation-status": "Status",
    "public-invitation-status-confirmed": "Bestätigt",
    "public-invitation-status-invited": "Eingeladen",
    "public-invitation-status-registered": "Registriert",
    "public-invitation-status-rejected": "Abgelehnt",
    "public-invitation-status-submitted": "Eingereicht",
    "public-invitation-title": "Einladung zur Veranstaltung",
    "public-invitation-unavailable": "Ihre Einladung konnte gerade nicht geprüft werden.",
    "public-registration-copy": "Text der öffentlichen Anmeldung",
    "public-registration-copy-iframe": "iframe kopieren",
    "public-registration-embed-allowlist": "Zulässige Domains für die Einbettung",
    "public-registration-embed-allowlist-description": "Domains, auf denen das öffentliche Formular eingebettet werden darf.",
    "public-registration-hosted-url": "Gehostete Anmelde-URL",
    "public-registration-iframe-snippet": "iframe-Einbettungscode",
    "push-channel-not-active": "Push nicht aktiv",
    "qr-active": "Aktiv",
    "qr-eligible": "Bereit",
    "qr-email-queued": "Die QR-E-Mail wartet auf die Zustellung.",
    "qr-event-setup-incomplete": "Schließen Sie die Veranstaltungseinrichtung ab, bevor Sie den QR-Code senden",
    "qr-image-load-failed": "Das QR-Bild konnte nicht geladen werden.",
    "qr-image-loading": "QR-Code wird geladen",
    "qr-image-retry": "QR-Bild neu laden",
    "qr-image-unavailable": "Das Bild dieser Einladung ist nicht verfügbar. Senden Sie die Einladung erneut, um einen neuen QR-Code zu erstellen.",
    "qr-ineligible-status-reason": "Nur für eingereichte, abgelehnte oder eingeladene Anmeldungen verfügbar",
    "qr-invalid-email": "Geben Sie vor dem Senden des QR-Codes eine gültige E-Mail-Adresse der teilnehmenden Person ein",
    "qr-invitation": "QR-Einladung",
    "qr-invitation-image": "QR-Code der Einladung",
    "qr-invitation-send-failed": "Die QR-Einladung konnte nicht gesendet werden",
    "qr-invitation-sent": "QR-Einladung in der Warteschlange",
    "qr-missing-email": "Fügen Sie vor dem Senden des QR-Codes eine E-Mail-Adresse der teilnehmenden Person hinzu",
    "qr-not-eligible": "Nicht bereit",
    "qr-not-ready": "Nicht bereit",
    "qr-ready-to-resend": "Aktiver QR-Code kann erneut gesendet werden",
    "qr-ready-to-send": "Bereit zum Senden",
    "qr-revoked-count": "Widerrufen",
    "qr-view": "QR-Code anzeigen",
    "question-type": "Fragetyp",
    "queued": "In Warteschlange",
    "reactivate": "Reaktivieren",
    "readiness": "Bereitschaft",
    "reconciled": "Abgeglichen",
    "reconciled-at": "Abgeglichen am",
    "registration": "Anmeldung",
    "registration-code": "Anmeldecode",
    "registration-codes": "Anmeldecodes",
    "registration-count": "{{count}} Anmeldungen",
    "registration-lifecycle": "Anmeldeverlauf",
    "registration-lifecycle.odbijen": "Abgelehnt",
    "registration-lifecycle.potvrden": "Bestätigt",
    "registration-lifecycle.pozvan": "Eingeladen",
    "registration-lifecycle.prijavljen": "Eingereicht",
    "registration-lifecycle.registriran": "Registriert",
    "registration-options-help-description": "Verwenden Sie diese Liste für Aktivitäten oder Zusatzleistungen, die auf der öffentlichen Anmeldeseite unter Zusätzliche Optionen angezeigt werden. Aktive kostenpflichtige Optionen erzeugen Angebotspositionen; reine Umfragefragen gehören nicht zur Einrichtung.",
    "registration-options-help-title": "Anmeldeoptionen sind betriebliche Zusatzleistungen.",
    "registration-state": "Anmeldestatus",
    "registration-status": "Anmeldestatus",
    "registration-vat": "MwSt. für Teilnahme und Aktivitäten",
    "registration-vat-default": "Standard-MwSt. für die Teilnahme",
    "registration-vat-required": "Die MwSt. für die Anmeldung ist erforderlich.",
    "registrations-rooming": "Anmeldungen und Zimmerreservierungen",
    "reject-registration": "Ablehnen",
    "release": "Freigeben",
    "release-room-reservation-confirm-description": "Nur die Zimmerreservierung wird freigegeben. Teilnehmende Person und Anmeldung bleiben in der Veranstaltung.",
    "release-room-reservation-confirm-title": "Diese Zimmerreservierung freigeben?",
    "renew-participation-offer-confirm": "Dieses abgelaufene Teilnahmeangebot mit den aktuell gültigen Preisen ersetzen?",
    "replace-customer-purchase-order": "Bestellung ersetzen",
    "replace-expired-offer": "Abgelaufenes Angebot ersetzen",
    "request-certificate": "Bescheinigung anfordern",
    "requested": "Angefordert",
    "requires-registriran": "Erfordert den Status Registriert",
    "requires-registriran-and-completed-event": "Erfordert den Status Registriert oder Bestätigt und eine abgeschlossene Veranstaltung",
    "resend": "Erneut senden",
    "resend-qr": "QR-Code erneut senden",
    "resend-verification-email": "Bestätigung erneut senden",
    "reservation-count": "{{count}} Reservierungen",
    "reservation-with-id": "Reservierung #{{reservationId}}",
    "reservations": "Reservierungen",
    "reserved": "Reserviert",
    "reserved-room-nights": "Reservierte Übernachtungen",
    "reserved-rooms": "Reservierte Zimmer",
    "reserved-rooms-count": "{{count}} reservierte Zimmer",
    "reset-password": "Passwort zurücksetzen",
    "retry": "Erneut versuchen",
    "review": "Prüfen",
    "revoked": "Widerrufen",
    "revoked-codes": "Widerrufene Codes",
    "revoked-codes-count": "{{count}} widerrufene Codes",
    "room": "Zimmer",
    "room-allotments-help-description": "Wählen Sie Hotel und Zimmertyp und geben Sie dann den Zeitraum, die Gesamtzahl der für diese Nächte verfügbaren Zimmer und optional eine Zahlungsfrist ein. Öffentliche Anmeldungen verbrauchen dieses Kontingent vor der Zahlung und können die verbleibenden Zimmer nicht überschreiten.",
    "room-allotments-help-title": "Zimmerkontingente sind der Bestand der Veranstaltung.",
    "room-allotments.hotels-missing": "Für diese Veranstaltung gibt es noch keine Hotels. Fügen Sie zuerst Hotels und Zimmertypen in der Einrichtung hinzu.",
    "room-allotments.room-types-missing": "Für diese Veranstaltung gibt es noch keine Zimmertypen. Fügen Sie zuerst Zimmertypen in der Einrichtung hinzu.",
    "room-allotments.select-event-before-create": "Wählen Sie eine Veranstaltung, bevor Sie Zimmerkontingente anlegen.",
    "room-count": "Anzahl der Zimmer",
    "room-reservation-choice": "Hotel / Zimmer",
    "room-reservation-count": "{{count}} Reservierungen",
    "room-reservation-release-failed": "Die Zimmerreservierung konnte nicht freigegeben werden.",
    "room-reservation-released": "Zimmerreservierung freigegeben.",
    "room-reservations": "Zimmerreservierungen",
    "room-type": "Zimmertyp",
    "room-type-unavailable": "Zimmertyp nicht verfügbar",
    "room-types": "Zimmertypen",
    "room-types-help-description": "Geben Sie an, welche Zimmerart das Hotel anbietet: Name, Kapazität pro Zimmer, Preis pro Nacht, MwSt. und Beschreibung. Wie viele Zimmer für die Veranstaltung verfügbar sind, wird hier nicht erfasst, sondern über Zimmerkontingente.",
    "room-types-help-title": "Zimmertypen sind der Hotelkatalog.",
    "rooming": "Rooming",
    "rooming-csv": "Rooming-CSV",
    "rooming-csv-download-error": "Rooming-CSV konnte nicht heruntergeladen werden. Bitte versuchen Sie es erneut.",
    "rooming-csv-download-success": "Rooming-CSV heruntergeladen.",
    "rooming-export-history": "Verlauf der Rooming-CSV-Exporte",
    "rooming-export-minimal-fields": "Export nur mit Unterkunftsdaten",
    "rooming-list": "Rooming-Liste",
    "rooming-operations": "Unterkunft und Rooming",
    "rooming-scope-description": "Verwenden Sie diese Liste und die CSV für Teilnehmende, Hotel, Zimmertyp, Aufenthaltsdaten und Zahlungsstatus der Unterkunft. Beim Freigeben einer Reservierung bleibt die teilnehmende Person in der Veranstaltung.",
    "rooming-scope-message": "Diese Liste enthält nur Unterkunftsdaten.",
    "row-actions": "Zeilenaktionen",
    "save-accommodation": "Unterkunft speichern",
    "save-activities": "Aktivitäten speichern",
    "save-participant-details": "Teilnehmerdaten speichern",
    "save-payer": "Zahler speichern",
    "save-payment-methods": "Zahlungsmethoden speichern",
    "save-profile": "Profil speichern",
    "save-registration": "Anmeldung speichern",
    "select-accommodation-status": "Unterkunft auswählen",
    "select-certificate-status": "Bescheinigung auswählen",
    "select-event": "Veranstaltung auswählen",
    "select-event-to-view-participant-export-history": "Wählen Sie eine Veranstaltung, um den Exportverlauf der Teilnehmenden anzuzeigen.",
    "select-event-to-view-rooming-export-history": "Wählen Sie eine Veranstaltung, um den Rooming-Exportverlauf anzuzeigen.",
    "select-event-to-view-rooming-list": "Wählen Sie eine Veranstaltung, um die Rooming-Details anzuzeigen.",
    "select-fee-status": "Teilnahmegebühr auswählen",
    "select-payer": "Zahler auswählen",
    "select-payer-placeholder": "Nach Name, E-Mail oder Steuernummer suchen",
    "select-qr-status": "QR-Status auswählen",
    "select-registration-status": "Status auswählen",
    "selected-event": "Ausgewählte Veranstaltung",
    "send-offer": "Angebot senden",
    "send-qr": "QR-Code senden",
    "sent-timeline": "Gesendet: {{value}}",
    "settings-source": "Quelle der Einstellungen",
    "setup-flow.accommodation": "Unterkunft",
    "setup-flow.accommodation-description": "Hotels, Zimmertypen, Kontingente, Zahlungsfristen und Rooming-Bereitschaft.",
    "setup-flow.accommodation-optional": "Optional, sofern die Veranstaltung keine Zimmer anbietet",
    "setup-flow.accommodation-ready": "{{count}} Hotels eingerichtet",
    "setup-flow.activities": "Aktivitäten und Optionen",
    "setup-flow.activities-description": "Kostenpflichtige/kostenlose Optionen und Aktivitäten, die im Anmeldeablauf erscheinen sollen.",
    "setup-flow.activities-optional": "Optional, sofern die Veranstaltung keine Zusatzleistungen hat",
    "setup-flow.activities-ready": "{{count}} aktive Optionen",
    "setup-flow.basic": "Grunddaten und Grafiken",
    "setup-flow.basic-data-missing": "Visuelle Identität vorhanden; die Grunddaten müssen noch ergänzt werden",
    "setup-flow.basic-description": "Identität, Termine, öffentliche Inhalte, Hinweise vor Ort und Grafiken der Veranstaltung.",
    "setup-flow.basic-missing": "Grunddaten und visuelle Identität müssen noch ergänzt werden",
    "setup-flow.basic-ready": "Grunddaten und Grafiken sind bereit",
    "setup-flow.basic-visuals-missing": "Grunddaten sind bereit; die visuelle Identität muss noch ergänzt werden",
    "setup-flow.description": "Folgen Sie der Einrichtungsreihenfolge, die das ATI-Team vor dem Teilen der öffentlichen Anmeldung benötigt.",
    "setup-flow.done": "Bereit",
    "setup-flow.kicker": "Geführte Veranstaltungseinrichtung",
    "setup-flow.load-error": "Einrichtungsablauf kann nicht geladen werden",
    "setup-flow.open-accommodation": "Unterkunft öffnen",
    "setup-flow.open-activities": "Aktivitäten öffnen",
    "setup-flow.open-full-setup": "Einrichtung öffnen",
    "setup-flow.open-overview": "Übersicht öffnen",
    "setup-flow.open-pricing": "Preise öffnen",
    "setup-flow.open-registration-form": "Anmeldung öffnen",
    "setup-flow.open-settings": "Einstellungen öffnen",
    "setup-flow.optional": "Optional",
    "setup-flow.pricing": "Preise",
    "setup-flow.pricing-current-fee-missing": "Es gibt Gebührenpreise, aber keiner gilt heute. Prüfen Sie, ob der Preiszeitraum das heutige Datum abdeckt.",
    "setup-flow.pricing-description": "Gebührenzeiträume, Gebührenarten und Preise. Zahlungsmethoden bleiben in den Veranstaltungseinstellungen.",
    "setup-flow.pricing-disabled": "Die Teilnahmegebühr ist für diese Veranstaltung deaktiviert.",
    "setup-flow.pricing-fee-prices-missing": "Verbinden Sie jede Gebührenart mit einem Preiszeitraum, indem Sie Gebührenpreise hinzufügen.",
    "setup-flow.pricing-missing": "Fügen Sie Gebührenarten und Preiszeiträume hinzu oder bestätigen Sie, dass diese Veranstaltung keine Teilnahmegebühr hat.",
    "setup-flow.pricing-payment-methods-missing": "Die Gebührenpreise sind bereit, aber die Zahlungsmethoden für die Teilnahme sind noch nicht gespeichert. Speichern Sie Banküberweisung/Karte, bevor Sie das öffentliche Formular teilen.",
    "setup-flow.pricing-ready": "{{feeTypes}} Gebührenarten · {{periods}} Zeiträume · {{prices}} heute gültige Preise",
    "setup-flow.registration": "Anmeldeformular",
    "setup-flow.registration-description": "Teilen Sie den gehosteten öffentlichen Anmeldelink oder iframe und halten Sie das Live-Formular für Teilnehmende bereit.",
    "setup-flow.registration-missing": "Prüfen",
    "setup-flow.registration-ready": "Bereit",
    "setup-flow.required-ready": "Pflichtschritte bereit",
    "setup-flow.review": "Prüfen und starten",
    "setup-flow.review-description": "Prüfen Sie die Einrichtungsbereitschaft und den Anmeldelink, bevor der Veranstaltungsbetrieb beginnt.",
    "setup-flow.review-form-missing": "Prüfen Sie den Anmeldelink, bevor Sie die Anmeldung teilen",
    "setup-flow.review-missing": "Schließen Sie zuerst die Pflichtschritte ab",
    "setup-flow.review-ready": "Grundeinrichtung und Anmeldelink sind bereit",
    "setup-flow.title": "Bauen Sie die Veranstaltung in der erwarteten Reihenfolge auf",
    "setup-flow.todo": "Unvollständig",
    "setup-sequence.accommodation-description": "Optionale Einrichtung von Hotels, Zimmertypen, Zimmerkontingenten, Preisen und Zahlungsfristen. Die öffentliche Anmeldung verbraucht das Zimmerkontingent der Veranstaltung vor der Zahlung.",
    "setup-sequence.accommodation-plan-description": "Fügen Sie zuerst Hotelnamen hinzu, dann die buchbaren Zimmertypen und zuletzt das Zimmerkontingent und die Zahlungsfristen für die Anmeldung.",
    "setup-sequence.accommodation-plan-title": "Unterkunft der Reihe nach aufbauen",
    "setup-sequence.accommodation-title": "Unterkunft",
    "setup-sequence.activities-plan-description": "Hierher gehören nur Aktivitäten und Zusatzleistungen, die Anmeldung, Anwesenheit oder Zahlung betreffen. Reine Umfragefragen gehören nicht zur Einrichtung.",
    "setup-sequence.activities-plan-title": "Halten Sie diesen Schritt auf wählbare Zusatzleistungen beschränkt",
    "setup-sequence.activities-title": "Aktivitäten/Zusatzleistungen",
    "setup-sequence.basic-description": "Legen Sie Identität, Termine, kroatische und englische öffentliche Inhalte, Grafiken/Dokumente, Steuerwerte, Zahlungsmethoden und E-Mail-Texte fest, bevor Sie das Formular teilen.",
    "setup-sequence.basic-title": "Grunddaten",
    "setup-sequence.pricing-description": "Die Angabe zur Teilnahmegebühr und die Zahlungsmethoden bleiben in den Veranstaltungseinstellungen. Verwenden Sie diese Seite für Preiszeiträume, Teilnehmergebührenarten und Preise.",
    "setup-sequence.pricing-no-fee-description": "Sie können Gebührenzeiträume, Teilnehmergebührenarten und Preiszeilen leer lassen. Kehren Sie nur hierher zurück, wenn die Veranstaltung Gebühren erheben soll.",
    "setup-sequence.pricing-no-fee-title": "Diese Veranstaltung erhebt keine Teilnahmegebühr",
    "setup-sequence.pricing-plan-description": "Fügen Sie Preiszeiträume, Teilnehmergebührenarten und die verbindenden Preiszeilen hinzu.",
    "setup-sequence.pricing-plan-title": "Arbeiten Sie diesen Gebührenschritt von oben nach unten ab",
    "setup-sequence.pricing-title": "Gebühren",
    "setup-sequence.registration-title": "Anmeldeformular",
    "setup-sequence.settings-plan-description": "Speichern Sie zuerst die Grunddaten und prüfen Sie dann Steuerwerte und E-Mail-Texte für Teilnehmende, bevor Sie den Anmeldelink teilen.",
    "setup-sequence.settings-plan-title": "Schließen Sie diesen Schritt in drei Durchgängen ab",
    "sponsor-covered": "Vom Sponsor übernommen",
    "sponsor-payment": "Sponsorzahlung",
    "sponsored": "Gesponsert",
    "start-date-required": "Startdatum ist erforderlich.",
    "stay": "Aufenthalt",
    "stored-file": "Gespeicherte Datei",
    "stored-offer-history": "Verlauf gespeicherter Angebote",
    "stripe-open-payment": "Zahlungsseite öffnen",
    "stripe-payment-link": "Stripe-Zahlungslink",
    "stripe-payment-link-help": "Öffnen Sie die Zahlungsseite oder kopieren Sie den Link, um ihn mit dem Zahler zu teilen. Links laufen nach 30 Tagen ab.",
    "stripe-payment-unavailable": "Online-Zahlung nicht verfügbar",
    "stripe-payment-unavailable-help": "Prüfen Sie, ob Stripe eingerichtet ist, das Angebot aktuell ist und Kartenzahlungen für diese Veranstaltung aktiviert sind.",
    "stripe-refunded": "Erstattet",
    "subject": "Betreff",
    "successfully-saved-item": "Eintrag erfolgreich gespeichert",
    "system-data-title": "Systemdaten",
    "tax": "Steuer",
    "tax-scheme": "Steuermodell",
    "tax-scheme-ppo": "PPO / 0 % MwSt.",
    "tax-scheme-required": "Steuermodell ist erforderlich.",
    "tax-scheme-standard-vat": "Standard-MwSt.",
    "template": "Vorlage",
    "template-field": "Feld",
    "template-field-add": "Feld hinzufügen",
    "template-field-background-color": "Hintergrund",
    "template-field-background-opacity": "Deckkraft des Hintergrunds",
    "template-field-border-color": "Rahmen",
    "template-field-border-opacity": "Deckkraft des Rahmens",
    "template-field-border-radius": "Eckenradius",
    "template-field-border-width": "Rahmenbreite",
    "template-field-collapse": "Parameter ausblenden",
    "template-field-color": "Textfarbe",
    "template-field-expand": "Parameter bearbeiten",
    "template-field-font-family": "Schriftart",
    "template-field-font-size": "Schriftgröße",
    "template-field-font-style": "Stil",
    "template-field-font-style-italic": "Kursiv",
    "template-field-font-style-normal": "Normal",
    "template-field-font-weight": "Schriftstärke",
    "template-field-label": "Bezeichnung",
    "template-field-participant-field": "Teilnehmerfeld",
    "template-field-position-x": "X-Position",
    "template-field-position-y": "Y-Position",
    "template-field-remove": "Feld entfernen",
    "template-field-shadow": "Schatten",
    "template-field-size": "Größe",
    "template-field-source": "Quelle",
    "template-field-source-participant": "Teilnehmende Person",
    "template-field-source-static": "Statischer Text",
    "template-field-static-sample": "Text",
    "template-field-static-text": "Statischer Text",
    "template-field-type": "Typ",
    "template-field-type-qr": "QR-Code",
    "template-field-type-text": "Text",
    "template-fields": "Felder",
    "template-preview-download": "Vorschau herunterladen",
    "templates": "Vorlagen",
    "timestamp": "Zeitstempel",
    "title": "Titel",
    "total": "Gesamt",
    "totals": "Summen",
    "unallocated": "Nicht zugeordnet",
    "unknown-participant": "Unbekannte teilnehmende Person",
    "upload-customer-purchase-order": "Bestellung hochladen",
    "upload-file": "Datei hochladen",
    "validation.complete-required-fields": "Prüfen Sie die Pflichtfelder und versuchen Sie es erneut.",
    "validation.correct-invalid-values": "Prüfen Sie die eingegebenen Werte und versuchen Sie es erneut.",
    "vat": "MwSt.",
    "verification-email": "Bestätigungs-E-Mail",
    "verification-email-queue-failed": "Die Bestätigungs-E-Mail konnte nicht in die Warteschlange gestellt werden.",
    "verification-email-queued": "Bestätigungs-E-Mail in der Warteschlange.",
    "verified": "Bestätigt",
    "verified-registration-count": "{{count}} von {{total}} bestätigt",
    "view": "Ansehen",
    "enums:QUEUED": "In Warteschlange",
    "app-shell.account-menu": "Kontomenü",
    "app-shell.breadcrumb": "Navigationspfad",
    "app-shell.close-menu": "Menü schließen",
    "app-shell.home": "ATIventura – Startseite",
    "app-shell.language": "Sprache",
    "app-shell.main-navigation": "Hauptnavigation",
    "app-shell.open-menu": "Menü öffnen",
    "event-payments.actions": "Aktionen",
    "event-payments.amount": "Betrag",
    "event-payments.balance-paid": "Bezahlt",
    "event-payments.balance-partial": "Teilweise bezahlt",
    "event-payments.balance-unpaid": "Unbezahlt",
    "event-payments.due-date": "Fälligkeitsdatum",
    "event-payments.empty": "Für diese Veranstaltung gibt es noch keine Angebote",
    "event-payments.filter": "Angebotsfilter",
    "event-payments.filter-all": "Alle, einschließlich ersetzter",
    "event-payments.filter-current": "Aktuelle Angebote",
    "event-payments.filter-outstanding": "Offen",
    "event-payments.filter-paid": "Bezahlt",
    "event-payments.load-failed": "Angebote und Zahlungen konnten nicht geladen werden.",
    "event-payments.offer": "Angebot",
    "event-payments.open-payer": "Zahler öffnen",
    "event-payments.outstanding": "Offen",
    "event-payments.overdue": "Überfällig",
    "event-payments.paid": "Bezahlt",
    "event-payments.participant": "Teilnehmende Person",
    "event-payments.payer": "Zahler",
    "event-payments.search": "Angebot, teilnehmende Person oder Zahler suchen",
    "event-payments.status": "Angebotsstatus",
    "event-payments.type": "Typ",
    "event-workspace.payments": "Zahlungen",
    "change-payer": "Zahler ändern",
    "participant-payer-chosen-at-registration": "Der Zahler wird bei der Anmeldung der teilnehmenden Person gewählt.",
    "participant-payer-locked": "Diesem Zahler wurde bereits ein Angebot ausgestellt, daher kann der Zahler nicht geändert werden.",
    "participant-payer-required": "Wählen Sie zuerst einen Zahler.",
    "participant-payer-change-success": "Zahler geändert.",
    "participant-payer-change-failed": "Der Zahler konnte nicht geändert werden.",
    "organizer-registration.title": "Teilnehmende Person anmelden",
    "organizer-registration.submit": "Anmelden",
    "organizer-registration.payer-mode-new": "Neuer Zahler",
    "organizer-registration.payer-mode-existing": "Vorhandener Zahler",
    "organizer-registration.payer-required": "Wählen Sie einen Zahler.",
    "organizer-registration.verification-note": "Die teilnehmende Person erhält eine E-Mail zur Bestätigung der Adresse. Das Angebot wird nach der Bestätigung gesendet, wie bei der öffentlichen Anmeldung.",
    "organizer-registration.success": "Die teilnehmende Person ist angemeldet. Eine E-Mail zur Bestätigung der Adresse wurde gesendet.",
    "organizer-registration.unavailable": "Anmeldung nicht möglich: Die Veranstaltung ist abgeschlossen oder hat kein aktives Anmeldeformular.",
    "organizer-registration.load-failed": "Das Anmeldeformular konnte nicht geladen werden.",
    "qr-email-not-confirmed": "Die teilnehmende Person hat die E-Mail-Adresse noch nicht bestätigt",
    "enums:PRIJAVLJEN": "Angemeldet",
    "enums:ODBIJEN": "Abgelehnt",
    "enums:POZVAN": "Eingeladen",
    "enums:REGISTRIRAN": "Eingecheckt",
    "enums:POTVRDEN": "Bestätigt",
    "validation-required": "Pflichtfeld",
    "validation-invalid-email": "Geben Sie eine gültige E-Mail-Adresse ein.",
    "validation-invalid-phone": "Geben Sie eine gültige Telefonnummer ein.",
    "validation-invalid-linkedin": "Geben Sie eine LinkedIn-Profil-URL ein.",
    "event-config-delete-accommodation-options-none": "Wählen Sie mindestens einen Zimmertyp zum Löschen.",
    "template-event-data-unavailable": "Die Veranstaltungsdaten sind noch nicht geladen, daher kann die Vorlage nicht gespeichert werden. Laden Sie die Seite neu und versuchen Sie es erneut.",
    "notifications-send-reason-event": "Öffnen Sie zuerst eine Veranstaltung.",
    "notifications-send-reason-recipients": "Wählen Sie mindestens einen Empfänger.",
    "notifications-send-reason-channel": "Wählen Sie einen Kanal.",
    "notifications-send-reason-content": "Schreiben Sie den Nachrichteninhalt.",
    "notifications-send-reason-subject": "Geben Sie den E-Mail-Betreff ein.",
    "notifications-send-reason-reply-to": "Geben Sie eine Antwortadresse ein oder deaktivieren Sie die Antwortadresse."
}
